{
    "logo": "logo Cephable",
    "add": "Agregar",
    "all": "Todo",
    "edit": "Editar",
    "create": "Crear",
    "delete": "Borrar",
    "next": "Próximo",
    "previous": "Anterior",
    "search": "Buscar",
    "loading": "Cargando...",
    "reload": "Recargar",
    "cancel": "Cancelar",
    "copy": "Copiar",
    "save": "Listo",
    "saveAndFinish": "Guardar y Finalizar",
    "saveAndContinue": "Guardar y Continuar",
    "saved": "Salvado",
    "done": "Hecho",
    "back": "Atrás",
    "play": "Jugar",
    "pause": "Pausa",
    "success": "Éxito",
    "continue": "Continuar",
    "options": "Opciones",
    "share": "Compartir",
    "finish": "Finalizar",
    "finishEdit": "Lo terminé",
    "advancedOptions": "Ver Opciones Avanzadas",
    "authenticating": "Autenticando...",
    "skip": "Omitir",
    "close": "Cerca",
    "notFound": "Página no encontrada",
    "notFoundDescription": "¡Oh, no! ¡Hemos buscado por el mar y no encontramos tu página!",
    "exitSetup": "Salir de la configuración",
    "experimental": "Experimental",
    "letGetStarted": "¡Empecemos!",
    "exploreInputControls": "Explorar los controles de entrada",
    "when": "Cuando yo ...",
    "thenMacro": "Cephable ejecutará...",
    "controls": "Los Controles",
    "welcome": "Bienvenido.",
    "beta": "beta",
    "macroEmpty": "No hay macros que igualan con este criterio.",
    "you": "Tú",
    "step": "Paso",
    "steps": "Pasos",
    "learnMore": "Aprende Más",
    "dangerZone": "Zona Peligrosa",
    "connected": "Conectado",
    "notConnected": "No conectado",
    "connectAndLearn": "Conéctate y Aprende",
    "tryAgain": "Probar otra vez",
    "by": "Por {{value}}",
    "noName": "- sin nombre -",
    "details": "Detalles",
    "controlFeed": "Controlar la alimentación",
    "wifi": {
        "disconnected": "El wifi está desconectado.",
        "connected": "Wi-Fi está conectado.",
        "description": "Conéctese a una red Wi-Fi para que Cephable funcione con sus conexiones y software. Es posible que tenga limitaciones para usar sus controles actuales."
    },
    "signalR": {
        "disconnected": "La sincronización está desconectada.",
        "action": "Reconectar",
        "description": "Parece haber un problema con la sincronización de Cephable. Esto causará problemas al guardar la configuración o comunicarse con otras conexiones.",
        "disconnectedDevice": "No se puede sincronizar con {{name}}.",
        "disconnectedDeviceDescription": "Parece haber un problema con la sincronización, ya sea por autenticación o por conexión a internet. No se pueden enviar ni recibir datos de forma remota. Debe verificar ambos lados de la conexión.",
        "connected": "La sincronización está conectada.",
        "connectedDescription": "Cephable se sincroniza correctamente y debería comunicarse con sus conexiones y extensiones como se espera.",
        "swap": "Cambiar a la conexión del dispositivo local",
        "unlinkedDevice": "Conexión eliminada.",
        "unlinkedDeviceDescription": "Esta conexión ha sido desvinculada de su cuenta."
    },
    "billing": {
        "title": "Facturación",
        "expires": "Próxima facturación: {{value}}",
        "isEmployeeAccess": {
            "title": "Profesional",
            "titleLong": "Cephable Profesional",
            "short": "Pro",
            "description": "Cephable Professional brinda a los usuarios mayor poder de productividad, extendiendo la IA local y privada a capacidades generativas.",
            "supportedFeatures": {
                "tag": "Todo en Plus, más",
                "features": [
                    "Flujos de trabajo de IA en el dispositivo",
                    "gestión de organizaciones empresariales",
                    "Restricciones empresariales",
                    "Instalaciones ilimitadas en dispositivos",
                    "Controles de aplicación preentrenados ilimitados"
                ]
            }
        },
        "isDeveloperAccess": {
            "title": "Kit de desarrollo de software",
            "titleLong": "Kit de desarrollo de software de Cephable",
            "short": "Kit de desarrollo de software (SDK)",
            "description": "Los SDK de Cephable le permiten integrar poderosos controles adaptativos (voz, rostro, cabeza y más) en su software con un esfuerzo mínimo y un beneficio máximo.",
            "supportedFeatures": {
                "tag": "Todo en Plus, más",
                "features": [
                    "Compatibilidad con Windows y macOS",
                    "SDK livianos e integrables para entrada de voz, rostro, cabeza y acción rápida sin conexión",
                    "Compatibilidad de API/webhook para acciones de salida personalizadas",
                    "Documentación para desarrolladores",
                    "Proyectos de muestra",
                    "Convierta los comandos en automatización y navegación de documentos",
                    "Portal para desarrolladores para administrar sus proyectos, clientes de autenticación, tipos de dispositivos y más"
                ]
            }
        },
        "isStudentAccess": {
            "title": "Alumno",
            "titleLong": "Educación Cefaleable",
            "short": "Educación",
            "description": "Cephable Education promueve el aprendizaje personalizado y las aulas inclusivas. Cephable funciona sin conexión, se ejecuta en el dispositivo y no requiere integraciones de terceros.",
            "supportedFeatures": {
                "tag": "Todo en Plus, más",
                "features": [
                    "Instalaciones ilimitadas de dispositivos",
                    "Controles de aplicación ilimitados previamente entrenados",
                    "Uso compartido ilimitado de controles de aplicaciones personalizados"
                ]
            }
        },
        "viewProducts": "Ver productos",
        "description": "Administre la facturación de su organización, asientos, actualizaciones de suscripciones, renovaciones o cancelaciones.",
        "view": "Administrar la facturación",
        "isResellerAccess": {
            "title": "Revendedor",
            "titleLong": "Revendedor de Cephable",
            "description": "Cephable Reseller es una licencia paga que le permite crear nuevas organizaciones y asignar claves de licencia. Esto incluye el uso de Cephable con su propio paquete de software y la mejora de su experiencia de usuario.",
            "short": "Revendedor"
        },
        "error": "Comuníquese con el administrador del sistema para administrar su facturación.",
        "included": "Incluido con su licencia {{licenseType}}.",
        "upgrade": {
            "description": "Actualízate ahora y lleva tus controles al siguiente nivel.",
            "action": "Actualizar ahora",
            "error": "Error al actualizar. Inténtalo de nuevo más tarde.",
            "requiredDetail": "Se requiere una licencia {{licenseType}} para esta función. Siempre puedes actualizarla o iniciar una prueba gratuita en la configuración de tu cuenta.",
            "enableTextGeneration": "Genera contenido usando IA y tu voz.",
            "longDescription": "Actualice a una licencia de pago para acceder a todas las funciones de Cephable. Desde múltiples dispositivos hasta controles avanzados e integraciones personalizadas, Cephable tiene todo lo que necesita para alcanzar el siguiente nivel de productividad.",
            "compare": "Comparar planes",
            "enableAiDictation": {
                "title": "Actualice al dictado inteligente",
                "description": "Actualízate para desbloquear el dictado mejorado con IA. Puedo añadir puntuación, corregir mayúsculas y adaptarme a tu estilo para que tu escritura se vea impecable sin esfuerzo."
            }
        },
        "isPlusAccess": {
            "title": "Más",
            "titleLong": "Cephable Plus",
            "short": "Más",
            "description": "Cephable Plus es para usuarios avanzados que desean lograr más con voz inteligente, dictado inteligente, cientos de controles de aplicaciones y más.",
            "supportedFeatures": {
                "tag": "Todo lo del Básico, más",
                "features": [
                    "Controles de voz inteligentes (lenguaje natural)",
                    "Dictado inteligente (mejorado con IA)",
                    "Tareas inteligentes (generación, traducción, reescritura)",
                    "Cientos de controles de aplicaciones preentrenados"
                ]
            }
        },
        "personal": {
            "short": "Básico",
            "title": "Básico",
            "titleLong": "Cephable Basic",
            "description": "Cephable Basic es gratuito para siempre y está diseñado para ayudarte a moverte más rápido, expresarte y lograr tus objetivos a tu manera. Las funciones incluidas en la versión básica están disponibles para todos los usuarios.",
            "upgrade": {
                "title": "Lleva tus controles al siguiente nivel",
                "description": "Actualízate a Plus o Pro para desbloquear todas mis funciones. Más precisión. Más conexiones. Más controles. Más potencia para llevar tu productividad al siguiente nivel.",
                "featureHeading": "Así es como puedo ayudarte:",
                "control": "Te muevo por las apps y herramientas más rápido usando tu voz o acciones rápidas, sin interrupciones. Con Voz Inteligente, podemos simplemente chatear.",
                "create": "Reescribo, dicto, genero y traduzco directamente dentro de tus aplicaciones, sin necesidad de copiar, pegar ni cambiar de pantalla.",
                "automate": "Ejecuto tareas inteligentes y acciones rápidas que agilizan tu flujo de trabajo. Desde comandos sencillos hasta macros complejas, me encargo del trabajo pesado para que puedas concentrarte en el trabajo que importa.",
                "local": "Toda la IA es local. Sin procesamiento en la nube."
            }
        },
        "mostPopular": "Más populares",
        "subscription": {
            "options": "Opciones de suscripción",
            "monthly": "Pagar mensualmente",
            "billedMonthly": "/mes",
            "yearly": "Pagar anualmente",
            "billedYearly": "/año"
        }
    },
    "organization": {
        "title": "Organización",
        "titlePlural": "Organizaciones",
        "titleLong": "Cephable Profesional para Organizaciones",
        "description": "Las organizaciones son grupos de usuarios que pueden colaborar en proyectos y compartir recursos. Puede administrar tu equipo, perfiles de equipo, facturación y más aquí.",
        "noAccess": {
            "title": "Acceso denegado.",
            "description": "Tus permisos cambiaron recientemente y ya no tienes acceso a esta función. Si cree que se trata de un error, comuníquese con el administrador de tu organización."
        },
        "member": {
            "title": "Miembro",
            "titlePlural": "Miembros",
            "me": "Mi membresía",
            "description": "Los miembros son usuarios que forman parte de tu organización. Se les puede asignar roles diferentes y tener acceso a diferentes partes de la organización.",
            "edit": "Editar miembros",
            "removed": "Has sido eliminado de un equipo.",
            "removedDescription": "Has sido eliminado del equipo. Ya no puedes acceder a la organización. Si cree que se trata de un error, comuníquese con el administrador de tu organización.",
            "updated": "Éxito, la membresía de {{value}} ha sido actualizada.",
            "error": "Error al actualizar la membresía de {{value}}.",
            "delete": "Éxito, {{value}} ha sido eliminado.",
            "deleteError": "Error al eliminar {{value}}.",
            "deleteConfirmation": {
                "title": "¿Está seguro de que desea eliminar este miembro?",
                "description": "Una vez que elimines a este miembro, ya no tendrá acceso a la organización. Siempre podrás volver a invitarlo más tarde.",
                "confirm": "Sí, eliminar miembro"
            },
            "viewAll": {
                "title": "Ver todos los miembros",
                "description": "Vea todos los miembros de su organización y administre sus roles y permisos."
            },
            "seats": {
                "title": "Asientos de miembros",
                "description": "Cada miembro de tu organización tiene un puesto. El administrador de la organización puede cambiar el tipo de permisos que tienen.",
                "stats": "asientos fuera de {{value}}",
                "max": "Máximo de asientos",
                "current": "Asientos actuales",
                "limit": {
                    "title": "Se alcanzaron los asientos máximos",
                    "description": "Tu plan actual ha alcanzado el límite de {{ maxSeats }} asientos disponibles. No puedes invitar a más miembros. Ponte en contacto con tu administrador para actualizar el plan o administrar la asignación de asientos."
                },
                "updateLimit": {
                    "title": "Actualice su plan para agregar más asientos",
                    "description": "Tu plan actual ha alcanzado la cantidad máxima de plazas: {{ maxSeats }}. Actualiza ahora para desbloquear plazas adicionales y garantizar que tu equipo pueda seguir creciendo sin problemas.",
                    "action": "Plan de actualización"
                },
                "maxSeatValue": "Máximo de asientos: {{value}}"
            },
            "aboutMe": "Acerca de mí",
            "loadError": "Error al cargar miembros de la organización.",
            "orgTitle": "Miembros de {{value}}",
            "emailExists": "El correo electrónico ya existe en la organización. Por favor escribe un correo electrónico diferente."
        },
        "invite": {
            "title": "Invitar",
            "titlePlural": "invita",
            "description": "Se envían invitaciones a los usuarios para que puede particpan a tu organización. Puede invitar a usuarios a participar a tu organización y asignarles diferentes roles.",
            "edit": "Crear nueva invitación",
            "view": "Ver todas las invitaciones",
            "emailRequired": "Correo Electronico es requerido",
            "emailInvalid": "El correo electrónico es invalido. Por favor, escribe un correo electrónico válida.",
            "emailExists": "El correo electrónico ya tiene una invitación de la organización. Por favor, escribe una dirección de correo electrónico diferente.",
            "emailPlaceholder": "Escribe tu correo electrónico",
            "expiration": "Vence ",
            "delete": "Eliminar invitación",
            "confirm": "¿Estás seguro a eliminar esta invitación?",
            "confirmLong": "Una vez que elimine esta invitación, el usuario ya no podrá participar en la organización. Siempre puedes volver a invitarlos más tarde.",
            "accept": "Aceptar invitación",
            "acceptSuccess": {
                "title": "Bienvenido al equipo.",
                "description": "Te has unido exitosamente a la organización. ",
                "action": "Ver tu nueva organización"
            },
            "acceptError": {
                "title": "Oops. Parece que hay un problema.",
                "description": "Hubo un error al unirse a la organización. Por favor, volver a probar más tarde. Si el problema persiste, comuníquese con el administrador de tu organización. ",
                "action": "Volver a la página principal"
            },
            "send": {
                "success": "Invitación a {{value}} enviada.",
                "error": "Error al enviar la invitación a {{value}}.",
                "title": "Enviar invitación"
            },
            "viewDescription": "Ver todas las invitaciones actuales que no han sido aceptadas.",
            "new": "Invitar a un miembro",
            "stat": "invitaciones activas",
            "noInvites": {
                "title": "Sin invitaciones.",
                "description": "Parece que no hay invitaciones activas para tu organización."
            },
            "error": "Error al cargar invitaciones.",
            "orgTitle": "Invitaciones de {{ value }}",
            "editDescription": "Crea una nueva invitación para que un usuario se una a tu organización. Las invitaciones caducan automáticamente a los 7 días."
        },
        "role": {
            "title": "Role",
            "titlePlural": "Roles",
            "description": "Los roles son los diferentes niveles de acceso que puede tener un usuario en tu organización. Puede asignar diferentes roles a los usuarios para controlar lo que pueden hacer."
        },
        "isAdmin": {
            "title": "Administración",
            "description": "Los administradores tienen acceso completo a la organización y pueden manager todos los aspectos de la organización.",
            "conflict": "Este miembro es un administrador. No tienes permiso para editar tus roles."
        },
        "canViewMembers": {
            "title": "Ver miembros",
            "description": "Los usuarios con este permiso pueden ver a todos los miembros de la organización."
        },
        "canInviteMembers": {
            "title": "Invitar a los miembros",
            "description": "Los usuarios con este permiso pueden invitar a nuevos miembros a la organización y administrar las invitaciones existentes."
        },
        "canChangeMemberPermissions": {
            "title": "Cambiar roles de miembros",
            "description": "Los usuarios con este permiso pueden cambiar el role de otros miembros de la organización."
        },
        "canRemoveMembers": {
            "title": "Eliminar miembros",
            "titleSingle": "Eliminar miembro",
            "action": "Eliminar",
            "description": "Los usuarios con este permiso pueden eliminar a otros miembros de la organización.",
            "confirm": "¿Está seguro a eliminar a este miembro de la organización?",
            "confirmLong": "Una vez que elimines a este miembro, ya no tendrá acceso a la organización. Siempre puedes volver a invitarlos más tarde."
        },
        "canCreateAuthClients": {
            "title": "Crear clientes de autenticación",
            "description": "Los usuarios con este permiso pueden crear nuevos clientes de autenticación para la organización."
        },
        "canManageBilling": {
            "title": "Administrar facturación",
            "description": "Los usuarios con este permiso pueden administrar la configuración de facturación de la organización.",
            "error": "No tienes permiso para administrar la facturación de esta organización."
        },
        "metrics": {
            "lineChart": {
                "title": "Promedio de Conexiones Concurrentes",
                "description": "Este gráfico muestra las conexiones simultáneas promedio para la organización y los datos del proyecto a lo largo del tiempo.",
                "max": "Máximo de Conexiones: {{maxConnections}}",
                "project": "Total del Proyecto",
                "org": "Organización Total"
            },
            "title": "Métrica",
            "description": "Las métricas son puntos de datos que le ayudan a comprender cómo su organización utiliza Cephable.",
            "view": "Ver métricas",
            "orgTitle": "Métricas de {{ value }}",
            "manage": {
                "title": "Métricas de rendimiento",
                "description": "Descargue o borre las métricas de rendimiento recopiladas durante la inferencia del modelo."
            },
            "download": {
                "button": "Descargar métricas",
                "success": "El archivo de métricas se ha guardado en su carpeta de Descargas.",
                "error": "Error al descargar el archivo de métricas.",
                "noFile": "No se encontró el archivo de métricas. Intente ejecutar el modelo primero."
            },
            "clear": {
                "button": "Métricas claras",
                "success": "Se han borrado las métricas.",
                "error": "No se pudo borrar el archivo de métricas.",
                "confirm": {
                    "title": "Métricas de rendimiento claras",
                    "description": "¿Seguro que desea borrar todas las métricas de rendimiento registradas? Esta acción no se puede deshacer.",
                    "cancel": "Cancelar",
                    "confirm": "Métricas claras"
                }
            }
        },
        "noOrg": {
            "title": "Sin licencia asociada.",
            "description": "Actualmente no está asociado a ninguna licencia ni grupo de desarrolladores. El portal está limitado a usuarios con una licencia de pago de Cephable. Para aprovechar al máximo el potencial de Cephable, inicie una prueba gratuita."
        },
        "projects": {
            "title": "Proyectos",
            "description": "Utilice Proyectos para administrar el acceso seguro, configurar las interacciones de los dispositivos y optimizar la forma en que sus aplicaciones envían y reciben comandos en distintas plataformas.",
            "name": "Nombre de la aplicación",
            "stats": {
                "title": "Estadísticas del proyecto",
                "connections": "Conexiones totales",
                "all": {
                    "title": "Todas las métricas del proyecto",
                    "description": "Métricas agregadas para todos los proyectos asociados con {{ orgName }}"
                },
                "card": "proyectos de {{value}}",
                "users": "Total de usuarios desde {{date}}",
                "avgUsers": "Promedio mensual de usuarios.",
                "concurrent": {
                    "title": "Promedio de conexiones simultáneas Últimos {{days}} días",
                    "label": "Promedio simultáneo",
                    "max": "Conexiones máximas",
                    "overage": "Exceso",
                    "description": "Las conexiones simultáneas son la cantidad de usuarios conectados a tu proyecto al mismo tiempo. Esta métrica te ayuda a comprender cuántos usuarios están usando tu aplicación simultáneamente."
                }
            },
            "projectType": {
                "title": "Tipo de proyecto",
                "description": "Los tipos de proyecto se utilizan para categorizar sus proyectos y ayudarnos a elegir los SDK adecuados para usted."
            },
            "accessDenied": {
                "generic": "No tienes acceso a este proyecto.",
                "title": "Acceso denegado.",
                "description": "No tienes acceso para ver, crear, editar ni eliminar proyectos. Ponte en contacto con tu administrador para obtener acceso."
            },
            "upgrade": {
                "title": "Actualización al SDK de Cephable",
                "description": "Cephable se puede integrar directamente en su aplicación, juego o servicio mediante nuestros SDK. Los proyectos no están disponibles actualmente con su cuenta. Si cree que hay un error, comuníquese con support@cephable.com.",
                "shortDescription": "Los proyectos no están disponibles actualmente en tu cuenta. Ponte en contacto con nosotros para actualizar."
            },
            "limit": {
                "title": "¿Quieres más proyectos?",
                "error": "Se alcanzó el límite del proyecto.",
                "description": "Has alcanzado la cantidad máxima de proyectos para tu organización. Ponte en contacto con tu administrador para actualizar tu cuenta."
            },
            "create": {
                "title": "Crear proyecto",
                "titleLong": "Empecemos.",
                "first": {
                    "title": "Empiece con su proyecto.",
                    "description": "Parece que aún no has creado un proyecto. Las claves y dispositivos de cliente son esenciales para proteger la comunicación entre tus aplicaciones y nuestros servicios. Con una clave de cliente, podrás integrar controles de voz y de movimiento de la cabeza en tus aplicaciones de forma rápida y segura."
                },
                "details": {
                    "title": "Detalles del proyecto",
                    "description": "Cree un nuevo proyecto para administrar la autorización de su aplicación, las capacidades de los dispositivos y las integraciones de SDK. Siga los pasos a continuación para configurar interacciones seguras y personalizables para sus usuarios."
                }
            },
            "sdk": {
                "title": "Descargar el SDK",
                "description": "Obtenga acceso a nuestro potente SDK desarrollado para facilitar los controles adaptativos.",
                "select": {
                    "title": "Seleccionar SDK",
                    "description": "Seleccione el SDK que desea utilizar para este proyecto. Nuestros SDK permiten una integración perfecta de controles de voz y movimiento de la cabeza adaptables en diferentes plataformas."
                }
            },
            "clients": {
                "title": "Clientes de autorización",
                "description": "Los clientes de autorización administran el acceso seguro a sus aplicaciones. Defina un cliente de autorización para autenticar a los usuarios y controlar las interacciones con su aplicación.",
                "settings": "Configuración de autorización",
                "configure": "Configurar el cliente de autorización",
                "create": "Crear cliente de autorización",
                "max": "Máximo de proyectos: {{value}}"
            },
            "secret": {
                "title": "Secreto del cliente",
                "created": "Se ha creado su secreto de cliente.",
                "description": "Su secreto de cliente solo se mostrará una vez. Cópielo ahora y guárdelo en un lugar seguro. Úselo solo para su propio desarrollo. <br> <br> No lo comparta con servicios o aplicaciones de terceros.",
                "copy": "Copiar secreto",
                "rotate": {
                    "title": "Rotar secreto de cliente",
                    "description": "ADVERTENCIA: Esta acción revocará su secreto de cliente existente y creará uno nuevo. Para ello, deberá actualizar todos los datos de uso existentes en todas sus aplicaciones. Esta acción no se puede revertir.",
                    "error": "Error al rotar el secreto. Inténtalo de nuevo más tarde."
                }
            },
            "key": {
                "title": "Clave de cliente",
                "view": "Ver clave de cliente",
                "delete": {
                    "title": "Eliminar clave de cliente",
                    "description": "ADVERTENCIA: Esta acción eliminará su clave de cliente existente y todas las configuraciones relacionadas. Esta acción no se puede revertir.",
                    "error": "Error al eliminar su clave de cliente.",
                    "success": "Su proyecto ha sido eliminado."
                },
                "copy": "Copiar clave"
            },
            "tokenRedirect": {
                "title": "URL de redireccionamiento de tokens",
                "description": "Las URL de redireccionamiento de tokens son los puntos finales a los que se envían los tokens de acceso una vez completada la autenticación. Estas URL permiten que su aplicación reciba de forma segura los tokens necesarios para acceder a los datos y servicios del usuario."
            },
            "authRedirect": {
                "title": "URL de redireccionamiento de código de autorización",
                "description": "La URL de redireccionamiento de código de autorización es el punto final donde se envían los códigos de autorización después de que un usuario otorga permiso a su aplicación. Esta URL es esencial en los flujos de OAuth, ya que garantiza la transmisión segura del código de autorización desde el servidor de autorización a su aplicación, lo que le permite solicitar tokens de acceso en nombre del usuario."
            },
            "scopes": {
                "title": "Ámbitos",
                "titleLong": "Ámbitos de permisos de API",
                "configure": "Definir alcances",
                "description": "Los ámbitos definen los permisos que tendrá este cliente de autorización. Establezca ámbitos para limitar el acceso a datos y funciones específicos, garantizando que los usuarios solo obtengan el acceso que necesitan.",
                "manage": "Administrar los ámbitos de autorización"
            },
            "deviceScopes": {
                "title": "Tipos de dispositivos asociados",
                "titleLong": "Tipos de dispositivos permitidos",
                "action": "Agregar nuevo tipo de dispositivo",
                "configure": "Configurar los tipos de dispositivos permitidos",
                "descriptionShort": "Define qué tipo de dispositivos pueden acceder a este proyecto.",
                "titles": "Tipos de dispositivos asociados",
                "description": "El tipo de dispositivo define los permisos y niveles de acceso que tiene un dispositivo dentro de su aplicación. Al asignar tipos de dispositivos específicos, puede controlar las acciones y los datos a los que puede acceder cada dispositivo, lo que garantiza que su aplicación se mantenga segura y cumpla con sus políticas de privacidad."
            },
            "deviceType": {
                "title": "Tipos de dispositivos",
                "description": "Un DeviceType define una categoría de dispositivos, detallando sus capacidades de entrada/salida y las funciones admitidas (por ejemplo, voz, gestos, tipos de controlador). Garantiza que solo los dispositivos autorizados puedan interactuar con una aplicación, lo que permite un acceso limitado a través de configuraciones de dispositivos específicos, como Xbox o PlayStation.",
                "action": "Crear tipo de dispositivo",
                "name": "Nombre del tipo de dispositivo",
                "descriptionLong": "Descripción del tipo de dispositivo",
                "features": {
                    "title": "Funciones compatibles",
                    "description": "Define las entradas y salidas que admite tu aplicación. Esto nos ayuda a optimizar la experiencia del usuario en Cephable.",
                    "supportsVoiceInput": "Entrada de voz",
                    "supportsPhysicalInput": "Entrada física",
                    "supportsKeyboardOutput": "Salida del teclado",
                    "supportsPlayStationControllerOutput": "Mando de PlayStation",
                    "supportsFaceInput": "Entrada de cara",
                    "supportsGestureInput": "Entrada de gestos",
                    "supportsXboxControllerOutput": "Mando Xbox",
                    "supportsDigitalExtensions": "Extensiones digitales",
                    "supportsPhysicalExtensions": "Extensiones físicas",
                    "supportsNintendoControllerOutput": "Mando de Nintendo",
                    "supportsGenericControllerOutput": "Salida del controlador genérico"
                },
                "canAutoStart": {
                    "title": "Admite arranques de control automático",
                    "description": "[canAutoStart] si está habilitado, el SDK verificará la configuración del usuario e intentará iniciar inmediatamente los controles de la cámara o el micrófono después de que el usuario inicie sesión."
                },
                "isSupported": {
                    "title": "Activo",
                    "description": "[isSupported] Si está deshabilitado, Cephable ya no enviará, recibirá ni reconocerá ningún dispositivo de usuario asociado con esto. Equivale a obsoleto."
                },
                "locale": {
                    "title": "Idioma predeterminado",
                    "description": "[defaultLocale] La configuración regional predeterminada para este tipo de dispositivo. Se utilizará como idioma predeterminado para el dispositivo.",
                    "support": "Admite idiomas",
                    "warn": "**Parece que tienes configurados controles personalizados. Asegúrate de haber actualizado los controles personalizados para los idiomas asociados.**",
                    "name": "{{lang}} - Nombre del tipo de dispositivo",
                    "langDescription": "{{lang}} - Descripción"
                },
                "customControls": {
                    "title": "Controles personalizados",
                    "object": "{{lang}} - Objeto de controles personalizados",
                    "description": "Los controles personalizados son una opción avanzada que permite a los usuarios configurar y editar manualmente los controles de la aplicación asociados a este dispositivo. Si desea que los usuarios controlen su dispositivo directamente desde Cephable, debe registrar los controles de su dispositivo aquí. Consulte la API de Cephable para obtener más información sobre las opciones."
                },
                "success": {
                    "title": "¡Éxito!",
                    "description": "Ha creado un nuevo tipo de dispositivo. {{name}} Ahora puede actualizar el alcance del dispositivo de su cliente de autorización según sea necesario."
                },
                "id": "Identificación del tipo de dispositivo",
                "throttleRules": {
                    "title": "Reglas del acelerador de comandos",
                    "description": "Configure reglas de limitación para controlar el flujo de comandos y las restricciones de entrada para este tipo de dispositivo.",
                    "disableVoiceInput": "Desactivar la entrada de voz",
                    "disableHotkeyInput": "Deshabilitar la entrada de teclas de acceso rápido",
                    "disableCameraInput": "Desactivar la entrada de la cámara",
                    "disableMultiInputs": "Deshabilitar entradas múltiples",
                    "maximumCommandsPerSecond": "Máximos comandos por segundo",
                    "maximumCommandsPerMinute": "Máximos comandos por minuto",
                    "maximumMacroLength": "Longitud máxima de macro"
                }
            },
            "view": "Ver proyectos",
            "error": "Error al cargar proyectos.",
            "type": {
                "title": "Tipo de implementación"
            },
            "originHost": {
                "title": "Origen del anfitrión",
                "description": "La URL que servirá como fuente principal de solicitudes y datos durante las interacciones de la API."
            },
            "orgTitle": "Proyectos de {{ value }}"
        },
        "viewOrganization": "Ver Organización",
        "update": "¡Tu organización ha sido actualizada! Actualizando la aplicación.",
        "error": "Error al cargar la organización. Inténtalo de nuevo más tarde.",
        "new": {
            "name": {
                "label": "Nombre de la organización",
                "placeholder": "Introduzca el nombre de su organización"
            },
            "description": {
                "label": "Descripción de la organización",
                "placeholder": "¿Cuáles son sus objetivos al utilizar Cephable Professional?"
            },
            "details": "Detalles de la organización"
        },
        "expired": {
            "user": "Parece que su licencia de Cephable ha expirado, por lo que ha cambiado a la versión gratuita de Cephable Basic. Para renovarla, póngase en contacto con el administrador de su organización.",
            "admin": "Parece que su licencia de Cephable ha expirado, por lo que ha cambiado a la versión gratuita de Cephable Basic. Renueve su licencia para seguir usando funciones avanzadas más allá de Cephable Basic.",
            "multiple": "Parece que sus licencias de Cephable han expirado, por lo que ha cambiado a la versión gratuita de Cephable Basic. Renueve al menos una de sus licencias para seguir usando funciones avanzadas más allá de Cephable Basic.",
            "dialog": {
                "title": "Seleccione una organización",
                "description": "Tiene varias organizaciones asociadas a su cuenta. Seleccione la organización que desea renovar."
            },
            "title": "Su licencia de Cephable ha expirado",
            "titlePlural": "Sus licencias de Cephable han expirado",
            "banner": "Parece que tu licencia de Cephable ha caducado, por lo que has cambiado a la versión gratuita de Cephable Basic. Al renovarla, tendrás acceso a funciones como controles de voz mejorados, tareas inteligentes con IA y muchos controles de aplicaciones predefinidos."
        },
        "orgName": "Nombre de la organización",
        "menu": {
            "title": "Menú de la organización",
            "view": "Ver Menú",
            "expand": "Expandir menú"
        },
        "settings": {
            "title": "Configuración de la organización",
            "description": "Administre la facturación, el nombre, la descripción y los recursos de su organización.",
            "view": "Ver configuración",
            "general": {
                "title": "General"
            },
            "resources": {
                "edit": "Editar recursos",
                "description": "Utilice el editor Markdown a la izquierda para actualizar y dar formato a recursos útiles para todos los miembros de la organización. A medida que escribe, la vista previa a la derecha mostrará cómo se verá su contenido para los usuarios. Puede agregar encabezados, listas, enlaces y otros elementos de formato utilizando la sintaxis Markdown. Los cambios serán visibles para los miembros una vez guardados."
            },
            "other": {
                "title": "Otros ajustes",
                "description": "Administre la facturación, el nombre, la descripción y los recursos de su organización."
            }
        },
        "managed": {
            "title": "Organización administrada",
            "titlePlural": "Organizaciones gestionadas",
            "description": "Las organizaciones administradas son aquellas que están a cargo de un revendedor de Cephable. Los revendedores pueden administrar su equipo, los perfiles del equipo, la facturación y más aquí.",
            "error": "Error al cargar organizaciones administradas.",
            "empty": {
                "title": "No se encontraron organizaciones administradas.",
                "description": "Parece que no hay organizaciones administradas que cumplan con estos criterios o que sus claves de licencia aún no se han activado."
            },
            "titleShort": "Administrado"
        },
        "canManageChildOrganizations": {
            "title": "Administrar organizaciones infantiles",
            "description": "Los usuarios con este permiso pueden crear y administrar organizaciones secundarias como administrador."
        },
        "canViewAnalytics": {
            "title": "Ver Analítica",
            "description": "Los usuarios con este permiso pueden ver las métricas y los análisis de la organización."
        },
        "create": "Crear nueva organización",
        "orgCustomBillingUrl": {
            "title": "URL de facturación personalizada",
            "description": "Esta es una URL personalizada que se utilizará para redirigir al usuario a su sistema de facturación (el del revendedor). Debe comenzar con \"https://\" o \"mailTo:\""
        },
        "upgrade": {
            "existing": {
                "title": "Eres parte de una licencia existente.",
                "description": "Actualice haciendo clic en `{{action}}` en el menú lateral."
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "IA generativa deshabilitada",
                "description": "Su organización ha deshabilitado el acceso a las funciones de IA Generativa. Para más información, póngase en contacto con el administrador de su organización."
            },
            "isRemoteControlDisabled": {
                "title": "Sincronización entre dispositivos deshabilitada",
                "description": "Su organización ha deshabilitado el acceso a la sincronización; no podrá usar nuestra aplicación complementaria ni controlar dispositivos externos. Para obtener más información, póngase en contacto con el administrador de su organización."
            }
        },
        "troubleshooting": {
            "title": "Solución de problemas",
            "editorDescription": "[Opcional] Esta es una sección que es visible para todos los usuarios a través de la página de detalles de conexión en las aplicaciones móviles y de escritorio de Cephable.",
            "description": "Si tiene problemas con Cephable, pruebe los pasos a continuación para resolver problemas comunes."
        },
        "onboarding": {
            "title": "Incorporación",
            "editorDescription": "[Opcional] La incorporación se muestra a los usuarios cuando se añade este tipo de dispositivo a su cuenta. Este es un excelente lugar para proporcionar instrucciones sobre cómo configurar y usar el tipo de dispositivo con su aplicación."
        },
        "documents": "Documentos",
        "completionStatus": {
            "title": "Estado de finalización",
            "error": "",
            "complete": "Completo.",
            "incomplete": "Incompleto."
        },
        "metadata": {
            "title": "Metadatos",
            "urlError": "La URL debe comenzar con http:// o https://",
            "metatitle": {
                "label": "Metatítulo",
                "placeholder": "Introduzca un título corto"
            },
            "shortDescription": {
                "label": "Descripción breve",
                "placeholder": "Ingrese una breve descripción de vista previa (máximo 150 caracteres)"
            },
            "externalLink": {
                "label": "URL del enlace externo",
                "placeholder": "https://ejemplo.com/información-del-dispositivo",
                "description": "Un enlace directo a un sitio web o recurso externo que proporciona más información sobre cómo configurar este dispositivo por primera vez. Si lo usa, no usaremos el Markdown de la lista de clientes."
            },
            "iconUrl": {
                "label": "URL del icono del dispositivo",
                "placeholder": "https://ejemplo.com/icono-de-dispositivo.png",
                "description": "Un enlace directo a una imagen que representa este tipo de dispositivo. Este icono se mostrará en la aplicación Cephable y en las listas de dispositivos."
            },
            "darkModeIconUrl": {
                "label": "URL del icono del dispositivo en modo oscuro",
                "placeholder": "https://ejemplo.com/icono-de-dispositivo-oscuro.png",
                "description": "Un enlace directo a una imagen que representa este tipo de dispositivo en modo oscuro. Este icono se mostrará en la app Cephable y en las listas de dispositivos cuando el usuario tenga activado el modo oscuro."
            },
            "editorDescription": "Cuando su dispositivo es seleccionado para aparecer en la aplicación Cephable como una extensión o conexión, utilizamos esta información para mostrársela a los usuarios que configuran nuevas conexiones."
        },
        "client-listing": {
            "title": "Listado de clientes",
            "editorDescription": "Instrucciones detalladas para que los nuevos usuarios configuren conexiones con este tipo de dispositivo. Este contenido de Markdown se mostrará en la aplicación Cephable cuando los usuarios agreguen una nueva conexión."
        },
        "canAccessOrganizationProfiles": {
            "title": "Ver controles de la aplicación de la organización",
            "description": "Los usuarios con este permiso pueden ver los controles de la aplicación de la organización asociados con esta organización."
        },
        "canEditOrganizationProfiles": {
            "title": "Administrar controles de aplicaciones de la organización",
            "description": "Los usuarios con este permiso pueden crear, editar y eliminar controles de aplicaciones de organización asociados con esta organización."
        },
        "profiles": {
            "title": "Controles de la aplicación de la organización",
            "description": "Los controles de aplicaciones de la organización son perfiles compartidos para distribuir controles de aplicaciones en toda su organización o para compartirlos con sus usuarios de integración.",
            "view": "Ver controles de la aplicación de la organización",
            "editDescription": "Edite los controles de la aplicación de la organización para personalizar la configuración.",
            "empty": "No se encontraron controles de la aplicación de la organización. Crea uno para empezar.",
            "error": "Error al cargar los controles de la aplicación de la organización.",
            "titleShort": "Controles de la aplicación"
        },
        "canViewAuthClients": {
            "title": "Ver proyectos",
            "description": "Los usuarios con este permiso pueden ver los clientes de autenticación y los proyectos de la organización."
        }
    },
    "customControls": {
        "title": "Controles Globales y Dispositivos",
        "prefixDisclaimer": " Este es un control de prefijo; escuchará las palabras después del comando y luego buscará en la siguiente frase para encontrar coincidencias.",
        "allowPausedDisclaimer": " Este control funcionará incluso cuando el micrófono esté en pausa.",
        "conflictIndicators": {
            "warn": "Atención: ",
            "title": "Se detectaron conflictos de configuración de entrada",
            "globalControls": "Conflictos de configuración de control global",
            "deviceControls": "Conflictos de configuración de control de dispositivos",
            "usedInput": " se utiliza como entrada para ",
            "description": "Algunas de las entradas de los controles globales y de dispositivo que utiliza también se utilizan en uno o más controles de su aplicación. Esto puede causar conflictos al usar Cephable. En estos casos, siempre daremos prioridad al control de la aplicación sobre el control global o de dispositivo.",
            "item": "La entrada <strong>{{value}}</strong> se utiliza en los controles de su aplicación: ",
            "globalDescription": "Los siguientes controles globales tienen entradas en conflicto con los controles de su aplicación.",
            "deviceDescription": "Los siguientes controles del dispositivo tienen entradas en conflicto con los controles de su aplicación."
        },
        "globalControls": {
            "title": "Controles Globales",
            "empty": "Tú no tienes controles globales. Puede crear uno ahora.",
            "edit": "Editar Controles Globales",
            "description": "Los controles globales son controles que siempre están disponibles, independientemente de la aplicación o el dispositivo que uses. Algunos incluso funcionan cuando los controles del micrófono o la cámara están en pausa."
        },
        "deviceControls": {
            "title": "Controles del Dispositivo",
            "empty": "Tú no tienes controles de dispositivo. Puede crear uno ahora.",
            "edit": "Editar Controles del Dispositivo",
            "controls": {
                "cephable-open-app": {
                    "success": "Abrir aplicación: {{value}}",
                    "error": "No se puede encontrar la aplicación: {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["cerca"],
                    "name": "Cerrar aplicación por nombre",
                    "description": "Utilice este comando con controles de voz para cerrar una aplicación en su computadora por nombre.",
                    "success": "Cerrar aplicación: {{value}}",
                    "error": "No se puede encontrar la aplicación: {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["minimizar"],
                    "name": "Minimizar la aplicación actual en foco.",
                    "description": "Utilice este comando con controles de voz para minimizar la aplicación actual en foco.",
                    "success": "¡Minimiza el éxito de las aplicaciones enfocadas!",
                    "error": "Error al minimizar la aplicación enfocada."
                },
                "cephable-maximize-focused-app": {
                    "commands": ["maximizar"],
                    "name": "Maximizar la aplicación actual en foco.",
                    "description": "Utilice este comando con controles de voz para maximizar la aplicación actual en foco.",
                    "success": "¡Maximice el éxito de su aplicación enfocada!",
                    "error": "Error al minimizar la aplicación enfocada."
                },
                "cephable-generate-text": {
                    "commands": ["generar"],
                    "name": "Genere texto proporcionando el mensaje que sigue a este comando.",
                    "description": "Utilice este comando con controles de voz seguido de su mensaje para generar un texto relacionado."
                },
                "cephable-stop-generate-text": {
                    "commands": [
                        "dejar de generar",
                        "detener la generación",
                        "cancelar generar",
                        "cancelar generación"
                    ],
                    "name": "Deja de generar texto.",
                    "description": "Utilice este comando con controles de voz para dejar de generar texto"
                },
                "cephable-open-panel": {
                    "commands": ["panel de exhibición"],
                    "name": "Abra el panel de Cephable",
                    "description": "Utilice este comando con controles de voz para abrir el panel de Cephable."
                },
                "cephable-close-panel": {
                    "commands": ["ocultar panel"],
                    "name": "Ocultar el panel Cephable",
                    "description": "Utilice este comando con controles de voz para ocultar o minimizar el panel de Cephable."
                },
                "cephable-close-focused-app": {
                    "commands": ["corriente cerrada"],
                    "name": "Cierra la aplicación actual en foco.",
                    "description": "Utilice este comando con controles de voz para cerrar la aplicación actual en foco.",
                    "success": "Cerrar aplicación actual ¡éxito!",
                    "error": "Error al cerrar la aplicación actual."
                },
                "cephable-rewrite-text": {
                    "commands": ["volver a escribir"],
                    "name": "Reescriba el texto proporcionando la indicación después de este comando.",
                    "description": "Utilice este comando con controles de voz seguido de su indicación para reescribir el texto resaltado actual."
                },
                "cephable-summarize-text": {
                    "commands": ["resumir"],
                    "name": "Resuma el texto proporcionando la instrucción siguiente a este comando.",
                    "description": "Utilice este comando con controles de voz seguido de su mensaje para resumir el texto resaltado actual."
                },
                "cephable-translate-text": {
                    "commands": ["traducir"],
                    "name": "Traduzca el texto proporcionando la solicitud después de este comando.",
                    "description": "Utilice este comando con controles de voz seguido de su indicación para traducir el texto resaltado actual."
                },
                "cephable-click-by-name": {
                    "commands": ["grifo", "golpear", "navegar a", "ir a"],
                    "name": "Toque el elemento por nombre",
                    "description": "Toque algo en la página por su nombre, como \"tocar guardar\" para hacer clic en un botón llamado \"guardar\"."
                }
            },
            "description": "Los controles del dispositivo están vinculados al dispositivo o conexión específicos que uses. Están disponibles sin necesidad de añadirlos a los controles de tu app y son especialmente útiles para funciones o eventos que solo son compatibles con ciertos dispositivos."
        },
        "resetControls": {
            "title": "Restablecer Controles",
            "description": "El idioma de tu voz ha cambiado desde la última vez que actualizaste tus controles. Nota: Esto restablecerá tus controles para que coincidan con {{language}} y es posible que pierdas los comandos personalizados. ¿Estás seguro de que deseas restablecerlos?",
            "confirm": "Sí, restablecer controles",
            "error": "Se produjo un error al restablecer los controles. Inténtalo nuevamente más tarde."
        },
        "warn": "El micrófono no se ha iniciado. Debe iniciarlo para usar los controles globales y del dispositivo.",
        "changeProfile": {
            "success": "Cambiar los controles de la aplicación: {{value}}",
            "error": "No se pueden encontrar los controles de la aplicación: '{{value}}'"
        },
        "descriptionShort": "Los controles globales y de dispositivo son acciones siempre disponibles, diseñadas para funcionar en cualquier software. Los controles globales, como \"Detener cámara\", se aplican a todo el sistema y son independientes de la aplicación, mientras que los controles de dispositivo se adaptan a la conexión de cada dispositivo y ofrecen funciones más avanzadas que los controles estándar de la aplicación.",
        "description": "Los controles globales y de dispositivo son acciones siempre disponibles, diseñadas para funcionar en cualquier software. Los controles globales, como \"Detener cámara\", son para todo el sistema e independientes de la aplicación, mientras que los controles de dispositivo se adaptan a la conexión de cada dispositivo y ofrecen funciones más avanzadas que los controles estándar de la aplicación. Actualmente, se accede a estos controles mediante comandos de voz; sin embargo, próximamente añadiremos compatibilidad con otras entradas.",
        "noDevice": "Este paso usa una extensión personalizada que no has configurado para tu cuenta. Agrega la extensión para desbloquear este paso."
    },
    "notifications": {
        "title": "Notificaciones",
        "center": "Centro de notificaciones",
        "empty": "No tienes notificaciones en este momento. Vuelve a consultar en otro momento.",
        "seen": "Visto",
        "markAsRead": "Marcar como leído",
        "view": "Ver todas las notificaciones de {{value}}"
    },
    "unsaved": {
        "title": "Tiene cambios sin guardar.",
        "description": "Tiene cambios sin guardar. ¿Estás seguro de que quieres salir esta página?",
        "cancel": "Salir sin guardar",
        "confirm": "Guardar y Salir"
    },
    "login": {
        "welcome": "¡Bienvenidos a Cephable!",
        "subtitle": "Controle tu tecnología según <strong>tus propios</strong> términos.",
        "create": "Crear Una Cuenta",
        "signIn": "Iniciar Sesión",
        "loading": "Redirigiendo para iniciar sesión...",
        "error": "Se produjo un error al iniciar sesión. Inicie sesión nuevamente.",
        "existingAccount": "¿Ya tienes una cuenta?",
        "description": "Toma el control total de tu computadora, apps y juegos con Cephable: tu IA personal para acciones rápidas, comandos de voz, expresiones faciales, gestos, inclinación y más. Sin procesamiento en la nube. Solo un control perfecto que se mueve contigo."
    },
    "home": {
        "title": "Principal",
        "startControls": "¡Encenderlo!",
        "manage": "Configurar",
        "profileGenerate": {
            "title": "Ups. Parece que aún no tienes ningún control de aplicación.",
            "description": "Para que Cephable controle tu ordenador, necesitamos saber qué quieres controlar. Puedes crear controles de aplicación desde cero o pedirnos ayuda para crear uno con nuestro generador de controles."
        }
    },
    "wizard": {
        "description": "Luego, Cephable utilizará esta información para generar controles que usted podriá revisar y probar.",
        "includeDefaultKeysQuestion": "¿Incluye comandos de voz predeterminados para teclas y clics del ratón?",
        "placeholderAppName": "Microsoft Word, Minecraft, YouTube, Code, etc.",
        "generate": "Generar controles",
        "complete": {
            "title": "¡Muy bien, hemos terminado!",
            "description": "Haga clic en el botón abjajo para ver los controles que generamos. Podrás editar, agregar o eliminar manualmente cualquier aspecto para perfeccionarlo.",
            "viewControls": "Ver mis controles"
        },
        "error": {
            "emptyInput": "Seleccione al menos un método de entrada",
            "emptyApp": "Por favor ingresa al menos el nombre de una aplicación",
            "generatingProfile": "Error al generar controles de la aplicación"
        },
        "loading": {
            "title": "Estamos juntando todas las piezas",
            "description": "Esto puede tardar hasta aproximadamente un minuto. No abandones esta página ni regreses o dejará de generarse."
        },
        "selectedTips": {
            "title": "Consejo #{{count}}",
            "previous": "Consejo anterior",
            "next": "Siguiente consejo",
            "two": "Puede controlar la sensibilidad de tus entradas en la sección \"Configuración de control de expresión\" del panel principal. Esto le permitirá refinar aún más las formas en que Cephable interpreta las entradas específicas para usted. ¡Y Cephable mejora con el tiempo a medida que funciona contigo!",
            "three": "Después de configurar esto, tú tienes control total sobre la configuración. Le estamos brindando una línea de base, pero en cualquier momento puede cambiar el mapeo entre lo que hace y lo que hace en la computadora.",
            "four": "Puede imprimir tus controles para tener una copia física mientras usa Cephable. Sabemos que todo esto es nuevo y requiere algo de tiempo para acostumbrarse. ¡La práctica hace mejor!",
            "one": "¿Sabías que puedes usar Cephable en un dispositivo para controlar otro? Descarga Cephable en tu móvil, tableta o incluso en otra computadora y elige la conexión que quieres controlar (quizás esta). ¡Tus perfiles personales y de entrada son consistentes en todos! Solo asegúrate de que Cephable se esté ejecutando en tu dispositivo y conexiones."
        },
        "steps": {
            "one": "Paso 1. Escribe el nombre de la aplicación que quieres controlar.",
            "two": "Paso 2. Confirme los controles de entrada que quieres utilizar:",
            "three": "Paso 3. (opcional) ",
            "threeContinued": "Describe cualquier acción específica que te gustaría configurar para los comandos que usas comúnmente o por los que tienes una fuerte preferencia. Utilice un inglés sencillo como los que aparecen a continuación."
        },
        "noOptionsText": "Comience a escribir para encontrar una aplicación que quiere controlar.",
        "title": "Generar controles de aplicación",
        "titleLong": "Generar controles de aplicación",
        "try": "Pruebe el generador de control",
        "placeholder": "Asegúrate de que los comandos de voz sean cortos.\n\nQuiero poder decir \"adelante\" para pasar a la siguiente diapositiva de la presentación.\n\nQuiero usar el movimiento de la cabeza para mover el cursor y los controles de voz para editar atajos.\n\nAñadir botones de acción rápida para todos los movimientos y habilidades de mi personaje."
    },
    "macros": {
        "title": "Control",
        "titlePlural": "Control S",
        "description": "Los controles contienen una entrada (acción que le gusta inclinar la cabeza) y pasos que Cephable realizará después de que se haya registrado esa acción de entrada. Puede utilizar controles para crear una combinación de pasos que se activan con una única entrada.",
        "new": "Crear un nuevo control",
        "newDescription": "Cree un nuevo control para combinar múltiples pasos y entradas.",
        "add": "Agregar control",
        "create": "Crear un control",
        "name": {
            "title": "Nombre del control",
            "question": "¿Cómo quieres llamar a este control?",
            "description": "Asigne un nombre a tu control para que pueda encontrarlo fácilmente más tarde.",
            "placeholder": "acción que este control está haciendo como \"saltar\" o \"acercar\""
        },
        "empty": "Aún no tienes controles. Haga clic a continuación para crear uno.",
        "copySuffix": "{{name}}_copia"
    },
    "event": {
        "title": "Paso",
        "titlePlural": "Pasos",
        "previewSummaryPlural": "{{first}} y {{total}} eventos más",
        "add": "Agregar paso",
        "stepType": "Tipo de paso",
        "select": "Seleccione el tipo de paso que desea agregar.",
        "question": "¿Qué tipo de acciones quieres que realice Cephable?",
        "setup": "Configura tu paso",
        "description": "Los pasos son las acciones que Cephable realizará después de que se haya activado la entrada. Puede agregar varios pasos a un control para crear una combinación de acciones.",
        "expand": "Ampliar para ver el resto de pasos",
        "stepUp": "Mueve Paso Arriba",
        "stepDown": "Mueve paso Abajo",
        "stepCopy": "Copia paso",
        "stepRemove": "Elimine paso",
        "insertStep": "Inserte paso abajo",
        "showOptions": "Muestre opciones",
        "hideOptions": "Ocuelte opciones",
        "hold": "Tiempo de espera (en milisegundos)",
        "error": "Debes configurar tu paso.",
        "multiple": "Múltiples pasos",
        "deviceTypeCustomAction": {
            "title": "Acción de dispositivo personalizada"
        },
        "keyPress": {
            "title": "Presione la tecla o el botón ",
            "short": "Prensa",
            "fieldSet": "Teclas o botón para presionar",
            "label": "Tecla o Botón",
            "holdTime": "Tiempo de retención de la tecla (en milisegundos)",
            "description": "Presione una tecla del teclado sin usar el teclado.",
            "longDescription": "Esta función simula la pulsación de una tecla en tu teclado. Por ejemplo, si tiene dificultades para presionar teclas físicas, puede usar un comando de voz u otro método de entrada para \"presionar\" una tecla virtualmente.",
            "example": "Diga \"Intro\" para enviar un correo electrónico sin presionar físicamente la tecla Intro.",
            "timing": "Momento de pulsación de tecla",
            "tap": "Grifo",
            "tapLong": "Toque el botón",
            "latch": "Pestillo",
            "latchLong": "Mantener hasta que se suelte",
            "hold": "Sostener",
            "holdLong": "Mantener por una cantidad de tiempo",
            "toggle": "Alternar",
            "toggleLong": "Alternar acción",
            "release": "Soltar",
            "releaseLong": "Soltar acción",
            "latchLabel": "Mantenga presionado <strong>{{value}}</strong> hasta que se suelte",
            "tapLabel": "Toca <strong>{{value}}</strong>",
            "pressLabel": "Presione <strong>{{value}}</strong> durante <strong>{{time}}</strong> milisegundos",
            "remove": "Eliminar pulsación de tecla",
            "add": "Agregar tecla/botón para presionar"
        },
        "keyRelease": {
            "title": "Soltar tecla o botón",
            "short": "Liberar",
            "selected": "Claves seleccionadas para liberar",
            "description": "Suelta una tecla del teclado que hayas presionado y mantenido.",
            "longDescription": "Esta función simula la liberación de una tecla de tu teclado. Debe usarse junto con una pulsación de tecla que se mantiene indefinidamente. Por ejemplo, si tiene dificultades para presionar teclas físicas, puede usar un comando de voz u otro método de entrada para \"soltar\" una tecla virtualmente.",
            "example": "Diga \"Detener\" después de decir \"Activar\" para detener la ejecución.",
            "label": "Liberar <strong>{{value}}</strong>",
            "add": "Agregar tecla/botón para liberar",
            "remove": "Quitar liberación de clave"
        },
        "keyToggle": {
            "title": "Alternar tecla o botón",
            "short": "Palanca",
            "selected": "Teclas seleccionadas para alternar",
            "description": "Enciende o apaga una tecla del teclado como un interruptor de luz con un solo control.",
            "longDescription": "Esto activa o desactiva la función de una tecla, como un interruptor. Es útil para claves que desea conservar durante un período de tiempo indeterminado. Puede usar esto para mantener la misma acción tanto al presionar como al soltar o detener la tecla.",
            "example": "Diga \"Alternar ejecución\" para comenzar a ejecutar. Diga \"Alternar ejecución\" para detener la ejecución.",
            "label": "Alternar <strong>{{value}}</strong>",
            "add": "Agregar tecla/botón para alternar",
            "remove": "Quitar palanca de clave"
        },
        "pause": {
            "title": "Pausa",
            "description": "Agregue un breve retraso entre acciones.",
            "longDescription": "Esta función le permite insertar un breve retraso entre acciones, lo cual es esencial en situaciones en las que una acción debe completarse por completo antes de que comience la siguiente. Por ejemplo, si está utilizando un comando para poner el texto en negrita en un documento, es posible que primero deba abrir un menú contextual. La función Pausa da tiempo suficiente para que el menú contextual se abra y se active antes de continuar con el siguiente paso, lo que garantiza un funcionamiento fluido y sin errores.",
            "example": "Imagina que estás editando un documento usando comandos de voz. Dices \"Formate texto\", lo que abre un menú contextual. Luego, después de una breve pausa para permitir que el menú aparezca por completo, dice \"Negrita\" para aplicar formato en negrita al texto seleccionado. La función Pausa garantiza que el menú contextual esté listo para recibir tu siguiente comando.",
            "label": "Pausa durante <strong>{{value}}</strong> milisegundos"
        },
        "type": {
            "title": "Escribir",
            "field": "Frase a escribir",
            "placeholder": "frase escrita",
            "question": "¿Qué texto quieres escribir?",
            "description": "Escriba texto como si usara un teclado.",
            "longDescription": "Esto imita la escritura de una cadena de texto, similar a escribir en un teclado. Es ideal para ingresar texto más largo sin necesidad de presionar cada tecla. Si desea ingresar texto dinámicamente, puede usar la función de Dictado.",
            "example": "Diga \"Nombre\" para escribir \"Hola, mi nombre es Ellen Ripley\". en una ventana de chat.",
            "label": "Escribe <strong>{{value}}</strong>"
        },
        "mouseMove": {
            "title": "Mueve el ratón",
            "description": "Mueva el puntero en la pantalla.",
            "longDescription": "Mueva el cursor o puntero de tu pantalla sin un ratón físico. Esto es especialmente útil para usuarios con movilidad limitada de las manos. Esto es útil para el control preciso del movimiento del ratón que se necesita en algunos juegos. Si desea simular todo el movimiento del ratón usando el movimiento de tu cabeza, puede probar el 'Movimiento de la cabeza para el control del ratón' en la configuración de la cámara.",
            "example": "Diga \"Mueve ratón Derecha\" para mover el cursor 100 píxeles hacia la derecha.",
            "moveX": "Mueve píxeles hacia la izquierda/derecha con el ratón",
            "numberMoveX": "Número de píxeles para mover hacia la izquierda/derecha",
            "moveY": "Mueve píxeles hacia arriba/abajo con el ratón",
            "numberMoveY": "Número de píxeles para mover hacia arriba/abajo",
            "label": "Mueve el ratón <strong>{{value}}</strong>",
            "command": "Movimiento del ratón: {{command}}"
        },
        "joystickMove": {
            "title": "Mover palancas de mando",
            "description": "Utilice un joystick para mover cosas en la pantalla.",
            "longDescription": "Esta función simula el movimiento de un joystick. Por ejemplo, si tiene dificultades para usar un joystick físico, puede usar un comando de voz u otro método de entrada para mover un joystick virtualmente.",
            "example": "Diga \"Mueve Joystick Izquierda\" para mover el joystick hacia la izquierda 100 píxeles.",
            "prefix": "Mueva El Joystick Izquierda",
            "left": "Palanca Izquierda",
            "leftX": "X Izquierdo",
            "leftY": "Y Izquierdo",
            "right": "Palanca Derecha",
            "rightX": "X Derecho",
            "rightY": "Y Derecho",
            "x": "Fuerza del eje X",
            "y": "Fuerza del eje Y",
            "moveXLabel": "Mueve X: {{value}}",
            "moveYLabel": "Mueve Y: {{value}}",
            "labelLeft": "Mueva el Joystick Izquierdo ",
            "labelRight": "Mueva el joystick Derecho ",
            "latch": "El pestillo mantendrá la posición hasta que lo sueltes utilizando el comando \"Detener todo\"."
        },
        "playAudio": {
            "title": "Reproducir audio",
            "placeholder": "frase de afirmacion que dira Cephable",
            "description": "Reproduce un sonido, palabra o frase.",
            "longDescription": "Esta función permite a los usuarios convertir frases escritas en palabras habladas. Es especialmente útil para personas que pueden tener dificultades para hablar. Al escribir una frase, la función PlayAudio articulará el texto en voz alta mediante voz sintetizada. Esto puede ayudar en la comunicación o en situaciones en las que un usuario necesita transmitir información verbalmente pero prefiere o requiere una alternativa al uso de tu propia voz.",
            "example": "Sonríe para reproducir la palabra \"Hola\".",
            "label": "Habla <strong>\"{{value}}\";</strong>"
        },
        "stopOutputs": {
            "title": "Detener todas las salidas",
            "titleLong": "Detenga todas las salidas (suelte todas las teclas y botones, detenga todos los movimientos del ratón, deje de escribir)",
            "description": "Detenga todas las acciones en curso, como presionar una tecla.",
            "longDescription": "Detenga inmediatamente todos los resultados o acciones en curso. Esta es una característica de seguridad o conveniencia para detener cualquier proceso. Haremos esto automáticamente cuando cierre o ponga en pausa los controles de la cámara o el micrófono.",
            "example": "Diga \"Detener\" para detener todas las salidas.",
            "label": "Detenga todas las salidas y suelte las teclas."
        },
        "custom": {
            "title": "Costumbre"
        },
        "options": {
            "moveUp": "Mueve Arriba",
            "moveDown": "Mueve Abajo",
            "moveLeft": "Mueve Izquierda",
            "moveRight": "Mueve Derecha",
            "copyStep": "Copia paso",
            "removeStep": "Elimine paso"
        },
        "directions": {
            "up": "Arriba",
            "down": "Abajo",
            "left": "Izquierda",
            "right": "Derecha"
        }
    },
    "expression": {
        "title": "Expresión Facial",
        "titlePlural": "Expresiones Faciales",
        "label": "Expresión / Gesto",
        "start": "Iniciar controles de expresión",
        "startSmiling": {
            "title": "Empezar a sonreír",
            "description": "Si empiezas a sonreír sin sonreír y luego lo haces, se activará este control. Nota: Usar este control en la misma aplicación que el control de apertura/cierre de boca puede causar conflictos."
        },
        "stopSmiling": {
            "title": "Deja de sonreír",
            "description": "Si sonríes y luego dejas de sonreír, se activará este control. Nota: Usar este control en la misma aplicación que el control de apertura/cierre de boca puede generar conflictos."
        },
        "eyebrows": {
            "title": "Levantar las cejas",
            "description": "Si levantas ambas cejas desde tu posición inicial de reposo, este control se activará."
        },
        "openMouth": {
            "title": "Boca abierta",
            "description": "Si tienes la boca cerrada (o si tu línea base está ligeramente abierta) y la abres más, se activará este control. Nota: Usar este control en la misma aplicación que el control de sonrisa puede causar conflictos."
        },
        "closeMouth": {
            "title": "Boca cerrada",
            "description": "Si tienes la boca abierta y la cierras por completo, se activará este control. Nota: Usar este control en la misma app que el control de sonrisa puede causar conflictos."
        },
        "description": "Mejora tu experiencia digital con expresiones faciales. Usa gestos como levantar las cejas, sonreír y otros movimientos para controlar el puntero del ratón, realizar acciones o personalizar tus interacciones."
    },
    "head": {
        "title": "Movimiento de Cabeza",
        "titlePlural": "Movimientos de Cabeza",
        "label": "Movimiento de cabeza/cuerpo",
        "question": "¿Qué tipo de movimiento quieres usar?",
        "tilt": {
            "title": "Inclinación de Cabeza",
            "left": {
                "title": "Incline la Cabeza Izquierda",
                "description": "Si estás mirando a la cámara e inclinas la cabeza hacia la izquierda, este control se activará."
            },
            "right": {
                "title": "Incline la Cabeza Derecha",
                "description": "Si estás mirando a la cámara e inclinas la cabeza hacia la derecha, este control se activará."
            },
            "back": {
                "title": "Incline la Cabeza Atrás",
                "description": "Si está mirando a la cámara e inclina la cabeza hacia atrás y mira hacia arriba, este control se activará."
            },
            "forward": {
                "title": "Incline la Cabeza Adelante",
                "description": "Si está mirando a la cámara e inclina la cabeza hacia adelante y mira hacia abajo, este control se activará."
            },
            "description": "Incline la cabeza hacia la izquierda o la derecha para un mejor control o navegación con el mouse."
        },
        "turn": {
            "title": "Giro de Cabeza",
            "left": {
                "title": "Gire la Cabeza Izquierda",
                "description": "Si está mirando a la cámara, gira la cabeza y mira hacia la izquierda, este control se activará."
            },
            "right": {
                "title": "Gire la Cabeza Derecha",
                "description": "Si está mirando a la cámara, gira la cabeza y mira hacia la derecha, este control se activará."
            },
            "description": "Gire la cabeza hacia la izquierda o hacia la derecha para un mejor control o navegación con el mouse."
        },
        "lean": {
            "title": "Cabeza Inclinada",
            "left": {
                "title": "Cabeza Inclinada Izquierda",
                "description": "Si está mirando a la cámara y se inclina hacia la izquierda para que tu cara quede más a la izquierda en el marco de la cámara, este control se activará."
            },
            "right": {
                "title": "Cabeza Inclinada Derecha",
                "description": "Si estás mirando a la cámara y te inclinas hacia la derecha para que tu cara esté más a la derecha en el marco de la cámara, este control se activará."
            },
            "back": {
                "title": "Cabeza Inclinada Atrás",
                "description": "Si está mirando a la cámara y se inclina hacia atrás para que tu cara esté más alejada de la cámara, este control se activará."
            },
            "forward": {
                "title": "Cabeza Inclinada Adelante",
                "description": "Si está mirando a la cámara y se inclina hacia adelante para que tu cara esté más cerca de la cámara, este control se activará."
            },
            "up": {
                "title": "Mueve Cuerpo Arriba",
                "description": "Si estás mirando a la cámara y mueves la cabeza hacia arriba estirando el cuello o moviendo todo el cuerpo hacia arriba, este control se activará."
            },
            "down": {
                "title": "Mueve Cuerpo Abajo",
                "description": "Si estás mirando a la cámara y mueves la cabeza hacia abajo arrugando el cuello, agachándote o bajando todo el cuerpo, este control se activará."
            },
            "center": {
                "title": "Centra tu Cabeza",
                "description": "Si está mirando a la cámara y mueve la cabeza hacia la posición central que coincide con la línea de base, este control se activará."
            },
            "description": "Incline la cabeza hacia la izquierda o la derecha para obtener un mejor control o navegación con el mouse."
        },
        "description": "Controla tu dispositivo o conexión con movimientos de cabeza como inclinar, asentir o girar. Con la cámara de tu dispositivo, Cephable garantiza una experiencia privada e intuitiva para un control mejorado o navegación con el ratón."
    },
    "voice": {
        "title": "Control de Voz",
        "titlePlural": "Controles de Voz",
        "placeholder": "Voz o frase que Cephable escuchará",
        "question": "¿Qué afirmación o frase quieres decir para este control?",
        "when": "Cuando yo digo...",
        "say": "Diga '{{value}}'",
        "load": {
            "fail": {
                "title": "Controles de voz en {{language}} no disponibles",
                "description": "¡Oh, no! No pudimos cargar {{language}} para los controles de voz. Por favor verifique tu conexión a Internet y inténtelo nuevamente. Cambiando al Inglés (Estados Unidos) hasta que hay conexión de internet."
            }
        },
        "description": "Al activar el micrófono, se activan comandos de voz inteligentes y naturales, lo que permite a los usuarios interactuar fluidamente con su computadora en diferentes aplicaciones y software. Hable con naturalidad para ejecutar comandos o dictar texto, creando una experiencia intuitiva y sin esfuerzo."
    },
    "motion": {
        "title": "Control de Movimiento",
        "titlePlural": "Controles de Movimiento",
        "question": "¿Qué tipo de movimiento con un teléfono o tableta quieres usar?",
        "start": "Iniciar Controles de Movimiento",
        "settings": "Configuración de movimiento",
        "descriptionShort": "Incline, gire o agite tu dispositivo para controlar Cephable.",
        "description": "Los controles de movimiento le permiten convertir el movimiento de tu teléfono o tableta en la aplicación complementaria en controles para tu dispositivo. Incline o agite tu teléfono en diferentes direcciones para crear nuevas salidas.",
        "up": {
            "title": "Incline Tu Dispositivo Arriba",
            "description": "Si tu dispositivo está plano sobre una superficie y lo inclina hacia usted, este control se activará."
        },
        "down": {
            "title": "Incline tu Dispositivo Abajo",
            "description": "Si tu dispositivo está plano sobre una superficie y lo inclina hacia abajo para mirar hacia afuera, este control se activará."
        },
        "left": {
            "title": "Incline Tu Dispositivo Izquierda",
            "description": "Si tu dispositivo está plano sobre una superficie y lo inclina hacia la izquierda, este control se activará."
        },
        "right": {
            "title": "Incline Tu Dispositivo Derecha",
            "description": "Si tu dispositivo está plano sobre una superficie y lo inclina hacia la derecha, este control se activará."
        },
        "shake": {
            "title": "Agite Tu Dispositivo",
            "description": "Si agita tu dispositivo, este control se activará."
        },
        "edit": {
            "title": "Editar configuración de movimiento",
            "description": "Cambie la configuración de control de movimiento para ajustar cuánto necesita mover tu teléfono mientras ejecuta la aplicación complementaria",
            "sensitivity": {
                "title": "Configuración de sensibilidad del control de movimiento",
                "description": "La sensibilidad le dice a Cephable hasta qué punto debe inclinar tu dispositivo para activar un control. Cuanto mayor sea el valor (más a la derecha en el control deslizante), mayor será la sensibilidad y, por lo tanto, menos necesitará inclinarse para activar el control."
            },
            "tilt": {
                "title": "Sensibilidad de Inclinación",
                "description": "Estos valores determinan cuánto debe inclinar tu dispositivo hacia arriba, abajo, izquierda y derecha para que se reconozca una entrada."
            },
            "mouse": {
                "title": "Controles de Movimiento para el Movimiento del Ratón",
                "description": "Determine si desea utilizar los controles de movimiento para mover el ratón y cómo hacerlo en lugar de activar los controles.",
                "enable": {
                    "title": "Habilitar controles de movimiento para el movimiento del ratón",
                    "description": "Si esto está activado, algunos de tus controles de movimiento se usarán para mover el ratón en lugar de los controles de activación.",
                    "option": "¿Utiliza controles de movimiento para el movimiento del ratón?"
                },
                "invert": {
                    "title": "Invertir el movimiento del ratón",
                    "description": "Para el eje X: si esto está activado, al moverlo hacia la izquierda se moverá el ratón hacia la derecha y si se mueve hacia la derecha lo moverá hacia la izquierda. Para el eje Y: si esto está activado, al moverlo hacia abajo, el ratón se moverá hacia arriba y al moverlo hacia arriba, lo moverá hacia abajo.",
                    "x": "¿Invertir el movimiento del ratón en el eje X?",
                    "y": "¿Invertir el movimiento del ratón en el eje Y?"
                }
            }
        }
    },
    "keys": {
        "title": "Tecla o Botón",
        "titlePlural": "Teclas o botones",
        "label": "Tecla/botón externo",
        "question": "¿Qué tecla o botón quieres presionar?",
        "edit": "Editar Teclas y Botones",
        "defaultOption": "¿Incluye comandos de voz predeterminados para teclas y clics del ratón?",
        "description": "Las teclas y botones le permiten asignar tus diferentes controles de entrada a las pulsaciones de botones del teclado y del controlador.",
        "then": "Cephable presionará...",
        "empty": "No hay controles clave que coincidan con este criterio.",
        "backspace": "Retroceso",
        "delete": "Borrar",
        "enter": "Ingresar",
        "space": "Barra espaciadora",
        "tab": "Pestaña",
        "shift": "Cambio",
        "ctrl": "Control",
        "leftCtrl": "Ctrl Izquierdo",
        "rightCtrl": "Ctrl Derecho",
        "leftShift": "Shift Izquierdo",
        "rightShift": "Shift Derecha",
        "alt": "Alt",
        "leftAlt": "Alt Izquierda",
        "escape": "Escapar",
        "up": "Flecha Arriba",
        "down": "Flecha Abajo",
        "left": "Flecha Izquierda",
        "right": "Flecha Derecha",
        "command": "Dominio",
        "caps": "Bloq Mayús",
        "reset": {
            "title": "Restablecer combinaciones de teclas",
            "confirm": "¿Restablecer todas las combinaciones de teclas?",
            "confirmDescription": "Elige cómo quieres restablecer las combinaciones de teclas. Esta acción no se puede deshacer sin guardar.",
            "confirmButton": "Restablecer la configuración de teclas",
            "defaultOption": "Restablecer a los valores predeterminados para el idioma actual.",
            "emptyOption": "Restablecer a vacío (borrar todos los comandos)"
        }
    },
    "talkback": {
        "title": "Replicar",
        "question": "¿Qué quieres que diga Cephable?",
        "description": "Controles de configuración que harán que Cephable hable por usted. Puedes asignar controles a diferentes frases que quieras que se pronuncien.",
        "thenMacro": "entonces Cephable dirá...",
        "empty": "No hay controles de talkback que coincidan con este criterio.",
        "add": "Agregar un nuevo control de conversación",
        "remove": "Quitar el control de conversación",
        "edit": "Editar controles de conversación",
        "deprecatedNotice": "Talkback ahora está integrado directamente en los controles principales de la aplicación. Tus controles de la aplicación tienen algunos eventos de Talkback antiguos que deben actualizarse."
    },
    "dictation": {
        "title": "Dictado",
        "question": "¿Qué frase debería activar el modo de dictado?",
        "thenMacro": "Cephable voluntad...",
        "empty": "No hay controles de dictado que coincidan con este criterio.",
        "type": "escribir a máquina",
        "edit": "Editar Frases de Dictado",
        "remove": "Eliminar Frase de Dictado",
        "add": "Agregar Nueva Frase de Dictado",
        "on": "Dictado",
        "off": "Comandos",
        "onboarding": {
            "tourLabel": "Dictado",
            "learn": "Aprenda a utilizar el modo de dictado para convertir su voz en texto sin necesidad de usar manos libres.",
            "welcome": {
                "title": "Dictado",
                "description": "El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."
            },
            "microphone": {
                "title": "Enciende tu micrófono",
                "description": "Primero, activa el micrófono. Haz clic en el interruptor de micrófono en el panel de Cephable."
            },
            "activate": {
                "title": "Iniciar el modo de dictado",
                "description": "La voz se inicia en modo comando. Para iniciar el dictado, diga \"Iniciar dictado\" o haga clic en el botón Dictado. Activemos el modo de dictado."
            },
            "speaking": {
                "title": "Haga clic en un documento o campo y comience a hablar",
                "description": "El dictado escribirá en tiempo real lo que digas. Haz clic en un campo de texto o documento y empieza a hablar. Por ejemplo, di: \"Así se usa el modo de dictado\"."
            },
            "pauseResume": {
                "title": "Pausa del dictado",
                "description": "¿Necesitas un descanso sin desactivar el dictado? Simplemente di \"Pausar dictado\". Puedes reanudarlo en cualquier momento con \"Iniciar dictado\". Puedes personalizarlo aún más con los controles globales y del dispositivo siempre activos."
            },
            "stop": {
                "title": "Detener el dictado",
                "description": "¿Necesitas volver a los controles de tu aplicación? Simplemente di \"Detener dictado\". Esto detendrá el modo de dictado y te permitirá volver al modo comando. Puedes reanudarlo en cualquier momento con \"Iniciar dictado\"."
            },
            "complete": {
                "title": "¡Felicitaciones!",
                "description": "¡Listo! Ahora puedes dictar, pausar, reanudar y alternar entre los modos de dictado y comando. El dictado es una herramienta potente para escribir sin usar las manos. Úsalo para escribir correos electrónicos, documentos o cualquier otra cosa que necesites escribir en voz alta."
            }
        },
        "description": "El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."
    },
    "face": {
        "title": "Expresión Facial",
        "titlePlural": "Expresiones Faciales",
        "try": "Pruebe los controles de expresión facial",
        "question": "¿Qué tipo de expresión facial quieres usar?",
        "descriptionShort": "Utilice diferentes movimientos faciales para obtener mejores controles.",
        "description": "Las expresiones faciales forman parte de los Controles de Expresión. Permiten usar diferentes movimientos faciales para un control mejorado. Puedes usar movimientos de cejas, de boca y más para crear diferentes resultados."
    },
    "other": {
        "title": "Otro Control",
        "titlePlural": "Otros Controles",
        "label": "Otros Controles",
        "placeholder": "otro comando experimental",
        "question": "¿Qué comando adicional le gustaría usar? Estos suelen ser para conexiones que no son Cephable y que no encajan en otras categorías. También pueden funcionar como comandos de voz al decir la palabra o frase especificada. Nota: Estos controles son experimentales y podrían no ser totalmente compatibles.",
        "description": "Otros controles son experimentales y podrían no ser totalmente compatibles. Pueden usarse para conexiones que no sean Cephable o como comandos de voz al decir la palabra o frase especificada."
    },
    "support": {
        "title": "Apoyo",
        "profiles": "Introducción a los controles de la aplicación",
        "question": "¿Aún no encuentras lo que necesitas?",
        "more": "Obtenga más información en Cephable.com con guías paso a paso, tutoriales, videos y más."
    },
    "community": {
        "title": "Unete a la communidad",
        "description": "Obtenga apoyo, comparta ideas o conviértase en miembro de las comunidades de Cephable.",
        "discord": "Discord",
        "facebook": "Facebook"
    },
    "resources": {
        "title": "Recursos útiles",
        "description": "Encuentre respuestas a tus preguntas sobre las características y funciones de Cephable.",
        "guides": "Guías Paso a Paso"
    },
    "feedback": {
        "title": "Comentario",
        "description": "Cuéntanos tu experiencia con Cephable.",
        "contact": "Contáctenos",
        "feature": "Sugerir una Característica",
        "bug": "Reportar un Problema"
    },
    "settings": {
        "title": "Ajustes",
        "general": "Configuración General de Aplicación",
        "description": "Este es tu lienzo para personalizar tu experiencia ajustando tus controles.",
        "orgTitle": "Configuración de {{ value }}"
    },
    "account": {
        "title": "Cuenta",
        "settings": "Configuraciones de la Cuenta",
        "description": "Actualice información clave para mantenerse conectado con Cephable.",
        "usernameLabel": "Nombre de Usuario: ",
        "emailLabel": "Correo Electrónico: ",
        "password": {
            "change": "Cambiar la Contraseña",
            "description": "Cambia tu contraseña para mantener tu cuenta segura.",
            "old": "Contraseña Anterior",
            "current": "Contraseña Actual",
            "new": "Nueva Contraseña",
            "desired": "tu nueva contraseña deseada",
            "confirm": "Confirmar Nueva Contraseña",
            "update": "Actualiza Contraseña"
        },
        "isEmailVerified": {
            "title": "Correo no Identificado.",
            "description": "Tu correo electrónico no está verificado. Por favor revise tu correo electrónico para obtener un enlace de verificación.",
            "resend": "Reenviar Correo",
            "success": "Te hemos enviado un nuevo correo electrónico de verificación.",
            "error": "Hubo un error al enviar el correo electrónico de verificación. Por favor, inténtelo de nuevo más tarde.",
            "org": "Su correo electrónico no está verificado. Es necesario para acceder a los detalles de la licencia. Por favor, revise su correo electrónico para ver si hay un enlace de verificación.",
            "titleAlt": "Verifique su dirección de correo electrónico",
            "descriptionLong": "¡Bienvenido a Cephable! Se ha enviado un correo electrónico de verificación a {{email}}. Revisa tu bandeja de entrada o correo no deseado y haz clic en el enlace. Si no lo ves, puedes reenviar el correo de verificación.",
            "appBlock": "¡Ya casi terminas! Se ha enviado un correo electrónico de verificación a {{email}}. Revisa tu bandeja de entrada y haz clic en el enlace para verificar tu dirección de correo electrónico. Si no lo ves, revisa tu carpeta de correo no deseado."
        },
        "signout": {
            "title": "Desconectar",
            "question": "¿Estás seguro de que deseas cerrar sesión?",
            "confirm": "Sí, cerrar sesión",
            "warn": {
                "title": "Estás a punto de cerrar tu sesión.",
                "description": "Parece que has estado inactivo durante un tiempo. Por razones de seguridad, cerraremos tu sesión en XX segundos. Si deseas permanecer conectado, haz clic en \"Permanecer conectado\" a continuación.",
                "confirm": "Mantenerse conectado",
                "cancel": "Cerrar sesión ahora"
            },
            "description": "Una vez que cierre la sesión, esta conexión se eliminará de su cuenta y ya no será visible desde la aplicación complementaria ni desde otras conexiones.",
            "confirmDescription": "Cerrar sesión y eliminar esta conexión"
        },
        "marketing": {
            "title": "Preferencias de Correo Electrónico",
            "description": "Suscríbase para recibir tutoriales, sugerencias, actualizaciones y boletines informativos para mejorar tú experiencia con Cephable.",
            "marketing": "Correos electrónicos de marketing",
            "optIn": "Me gustaría recibir tutoriales, consejos, actualizaciones y boletines para mejorar mi experiencia con Cephable."
        },
        "error": {
            "save": "Error al guardar la configuración de la cuenta.",
            "password": "Error al actualizar la contraseña.",
            "signout": "Error al cerrar sesión.",
            "old": "Se requiere contraseña anterior.",
            "new": "Se requiere una nueva contraseña.",
            "match": "Las contraseñas no coinciden.",
            "marketing": "Error al actualizar las preferencias de correo electrónico.",
            "userPreferences": "Error al guardar las preferencias del usuario."
        },
        "success": {
            "save": "Configuración de la cuenta guardada.",
            "password": "Contraseña actualiza.",
            "marketing": "Preferencias de correo electrónico actualizadas.",
            "userPreferences": "Preferencias de usuario actualizadas."
        },
        "userPreferences": {
            "title": "Preferencias del Usuario",
            "description": "Actualice tus preferencias para crear la experiencia Cephable que funcione para usted.",
            "warningOptOut": "Ocultar advertencias al guardar o actualizar los controles de la aplicación",
            "enableTranscribeTask": "Habilite la tarea de transcripción de archivos experimentales en el Panel de Cephable",
            "enableClickByName": "SOLO PARA WINDOWS. Habilita la función experimental \"Tocar\" un elemento en la pantalla por su nombre, como \"tocar guardar\" para hacer clic en un botón llamado \"guardar\".",
            "enableGamepadSupport": "Habilitar la compatibilidad del gamepad para el controlador local y la emulación del controlador Xbox",
            "enableMetrics": "Habilite la salida de métricas de uso para las pruebas de rendimiento. Podrá descargar los registros desde el panel de Cephable."
        },
        "menu": "Menú de usuario",
        "delete": {
            "title": "Eliminar cuenta",
            "description": "Puedes eliminar tu cuenta permanentemente y eliminar cualquier referencia a tu información personal. Al eliminar tu cuenta, tus conexiones se eliminarán y dejarán de funcionar o estar registradas en tu cuenta. Se perderán los controles de la aplicación y toda la configuración. Este proceso es irreversible.",
            "button": "Eliminar cuenta permanentemente",
            "confirmation": "¿Estás seguro que deseas eliminar tu cuenta?",
            "note": "Esta acción es irreversible.",
            "confirm": "Sí, eliminar mi cuenta"
        }
    },
    "appSettings": {
        "description": "Estas configuraciones solo se aplican a esta aplicación. Si desea cambiar la configuración de la aplicación Cephable en otra computadora o dispositivo móvil, edite la configuración en esa aplicación.",
        "autostart": {
            "title": "Iniciar Cephable Automáticamente",
            "description": "Con esta configuración activada, la aplicación Cephable se iniciará automáticamente cuando inicie sesión en tu dispositivo. Si también tienes controles automáticos de voz y expresión, estos también se iniciarán de inmediato.",
            "question": "¿Iniciar automáticamente la aplicación Cephable?"
        },
        "position": {
            "topLeft": "Arriba a la Izquierda",
            "top": "Arriba Centro",
            "topRight": "Arriba a la Derecha",
            "bottom": "Abajo Centro",
            "bottomLeft": "Abajo a la Izquierda",
            "bottomRight": "Abajo a la Derecha",
            "label": "Seleccionar la posición de alimentación del comando",
            "description": "Selecciona dónde quieres que aparezca el feed de comandos en tu pantalla."
        },
        "micPosition": {
            "title": "Posición de la Ventana de Entrada del <icrófono",
            "description": "Seleccione dónde desea que se coloquen los controles del micrófono para voz y dictado en tu pantalla.",
            "label": "Seleccione la posición de la ventana de entrada del micrófono"
        },
        "cameraPosition": {
            "title": "Posición de la Ventana de Entrada de Cámara",
            "description": "Seleccione dónde desea que se coloquen los controles de la cámara para el movimiento de la cara y la cabeza en tu pantalla.",
            "label": "Seleccionar posición de ventana de entrada de cámara"
        },
        "theme": {
            "title": "Pantalla y Brillo",
            "description": "Elige un brilla que se ajuste a tu estilo.",
            "light": "Claro",
            "dark": "Oscuro",
            "system": "Usar configuración del sistema operativo",
            "label": "Selecciona un Tema"
        },
        "overlay": {
            "title": "Alimentación de comandos",
            "description": "El feed de comandos mostrará los diferentes controles que usas y los que se enviaron a tu computadora. Es fácil de navegar, pero siempre estará sobre las demás ventanas. Con esta configuración activada, la aplicación Cephable se mostrará y siempre estará sobre las demás ventanas y aplicaciones.",
            "question": "¿Mostrar feed de comandos?"
        },
        "transparent": {
            "title": "Transparencia de la fuente de comandos",
            "description": "Determina la opacidad del texto. Cuanto menor sea el valor, más transparente será el texto."
        },
        "panelAutoHide": {
            "title": "Ocultar automáticamente el panel Cephable",
            "delay": "Retraso antes de esconderse",
            "denominator": "segundos",
            "time": "{{value}} segundos"
        },
        "title": "Configuración general de la aplicación"
    },
    "input": {
        "title": "Entradas",
        "titlePlural": "Controles de Entradas",
        "explore": "Explorar los Controles de Entradas",
        "descriptionShort": "Explore los diversos controles de entrada que utiliza Cephable para crear una mejor experiencia digital para usted.",
        "typeLabel": "Tipo de control de entrada",
        "toolTip": "Esto usa {{alt}}",
        "remove": "Eliminar control de entrada",
        "filter": "Filtrar por tipo de entrada",
        "select": "Seleccione una entrada",
        "question": "¿Qué tipo de entrada quieres usar?",
        "add": "Agregar Entrada",
        "addMore": "Agregar Otra Entrada",
        "removeItem": "Eliminar elemento {{index}}",
        "item": "Artículo {{index}}: {{label}}",
        "duplicate": "No se permiten artículos duplicados.",
        "maximum": "Se permite un máximo de {{maxItems}} artículos.",
        "description": "Los controles de entrada son los diferentes métodos que se utilizan para controlar el dispositivo, como la voz, el movimiento de la cabeza, las expresiones faciales y otras conexiones. Explora los diferentes controles de entrada a continuación para obtener más información."
    },
    "time": {
        "soon": "Muy pronto",
        "now": "Ahora",
        "today": "Hoy",
        "yesterday": "Ayer",
        "minutesAgo": "Hace {{count}} minuto",
        "minutesAgo_plural": "Hace {{count}} minutos",
        "daysAgo": "Hace {{count}} día",
        "daysAgo_plural": "Hace {{count}} días",
        "monthsAgo": "Hace {{count}} mes",
        "monthsAgo_plural": "Hace {{count}} meses",
        "yearsAgo": "Hace {{count}} año",
        "yearsAgo_plural": "Hace {{count}} años",
        "minutesAhead": "en {{count}} minutos",
        "todayAhead": "mas tarde, hoy",
        "tomorrow": "mañana",
        "daysAhead": "en {{count}} días",
        "monthsAhead": "en {{count}} meses",
        "yearsAhead": "en {{count}} años"
    },
    "peripherals": {
        "empty": "No se detectaron periféricos",
        "switch": "Cambiar",
        "keyboard": "Teclado",
        "gamepad": "Mando de juegos",
        "companionApp": "Aplicación complementaria",
        "available": "Disponible",
        "error": "Verifique tu configuración."
    },
    "camera": {
        "windowTitle": "Controles de Cámara Compatibles",
        "title": "Cámara",
        "titlePlural": "Cámaras",
        "settings": "Configuración de Cámara",
        "start": "Iniciar Cámara",
        "restart": "Reiniciar Cámara",
        "descriptionShort": "Permite expresión facial y movimiento de cabeza.",
        "description": "Utilice tu cámara para detectar expresiones faciales y gestos corporales como controles diferentes.",
        "empty": "No se encontraron cámaras.",
        "search": "Buscar por nombre de cámara",
        "loading": "Cargando controles de la cámara...",
        "error": "No se pudo cargar la cámara. Asegúrese de que su cámara esté conectada y habilitada.",
        "manage": {
            "title": "Haga clic para ver y administrar los detalles de tus cámaras.",
            "description": ""
        },
        "detected": {
            "face": "Cara detectada.",
            "noFace": "No se detectó ningún expresiones faciales. Ajuste tu cámara o posición e inténtelo de nuevo.",
            "command": "Detectado: {{command}}"
        },
        "permission": {
            "title": "Permisos de cámara requeridos",
            "description": "Debes darle permiso a Cephable para usar tu cámara y usar controles faciales y corporales.",
            "button": "Abrir configuración de permisos",
            "no": "Sin acceso a la cámara",
            "help": "Cephable necesita acceso a tu cámara para usar controles de expresión y cabeza. Navegue a <strong>Configuración del sistema</strong>  <strong>Privacidad</strong>  <strong>Cámara</strong> y habilite Cephable para acceder a tu cámara."
        },
        "controls": {
            "startData": "Comenzó a grabar datos faciales. Presione el acceso directo nuevamente mientras está en la ventana de la cámara para detener la grabación y la descarga.",
            "downloadData": "Se detuvo la grabación y la descarga de datos.",
            "paused": "Controles de cámara en pausa.",
            "pause": "Pausar controles de cámara",
            "resume": "Reanudar los controles de la cámara",
            "resumed": "Controles de cámara reanudados.",
            "linesOn": "Activar líneas faciales",
            "linesOff": "Desactivar las líneas de la cara",
            "linesToggle": "Alternar dibujar líneas de cara",
            "noDeviceTitle": "No se detectó ninguna cámara que pueda usarse con Cephable.",
            "noDeviceDescription": "Necesita conectar una cámara que sea compatible con aplicaciones móviles.",
            "noDeviceConnectedDescription": "El control de la cámara sirve como vista previa de la interfaz. Ningún paso se ejecutará exitosamente. Conecte este dispositivo complementario a otro para iniciar comandos.",
            "lines": "Líneas de la cara"
        },
        "switch": {
            "title": "Cambiar cámara",
            "description": "Seleccione una cámara diferente para usarla en los controles faciales y corporales.",
            "select": "Seleccionar cámara",
            "next": "Siguiente cámara",
            "nextLong": "Cambiar a la siguiente cámara",
            "empty": "No se encontraron otras cámaras.",
            "search": "Buscar por nombre de cámara"
        },
        "baseline": {
            "title": "Base",
            "description": "La línea de base es la posición predeterminada de tu cara y cuerpo que Cephable usa para determinar tus movimientos. Puede actualizar y restablecer la línea base aquí.",
            "update": "Actualizar línea base",
            "reset": "Restablecer línea base",
            "updated": "Línea de base actualizada",
            "tooltip": "Haga clic para actualizar tu línea base a tu posición de descanso actual."
        },
        "edit": {
            "title": "Editar la Configuración de la Cámara",
            "description": "Puede refinar la configuración de las entradas que requieren una cámara para que se adapten mejor a tus necesidades.",
            "autoStart": {
                "title": "Iniciar Cámara Automáticamente",
                "option": "¿Inicio automático de la cámara y controles de cabeza/expresión?",
                "description": "Con esta configuración activada, el controlador iniciará la cámara, lo que te permitirá usar expresiones faciales y controles de movimiento de cabeza al iniciar la aplicación. Si está desactivada, debes pulsar el botón \"Iniciar cámara\" en la página de conexión."
            },
            "head": {
                "title": "Sensibilidad al Movimiento de Cabeza",
                "description": "La sensibilidad le dice a Cephable qué tan lejos debe moverse para activar un control. Cuanto mayor sea el valor (más a la derecha en el control deslizante), mayor será la sensibilidad y, por lo tanto, menos necesitará moverse para activar el control.",
                "tilt": {
                    "title": "Sensibilidad a la Inclinación de la Cabeza",
                    "description": "Estos valores determinan qué tan lejos necesita inclinar la cabeza hacia arriba, abajo, izquierda y derecha para activar los controles.",
                    "up": "Sensibilidad de Inclinación Arriba",
                    "down": "Sensibilidad de Inclinación Abajo",
                    "left": "Sensibilidad de Inclinación Izquierda",
                    "right": "Sensibilidad de Inclinación Derecha",
                    "scaleHigh": "Ligera Inclinación",
                    "scaleLow": "Inclinación Grande"
                },
                "turn": {
                    "title": "Sensibilidad al Giro de Cabeza",
                    "description": "Estos valores determinan cuánto debe girar la cabeza hacia la izquierda y hacia la derecha para activar los controles.",
                    "left": "Sensibilidad de Giro Izquierda",
                    "right": "Sensibilidad al Giro Derecha",
                    "scaleHigh": "Ligero Giro",
                    "scaleLow": "Giro Grande"
                },
                "lean": {
                    "title": "Sensibilidad a la Inclinación de Cuerpo",
                    "description": "Estos valores determinan cuánto debe inclinar la cabeza hacia adelante y hacia atrás para activar los controles.",
                    "forward": "Sensibilidad Inclinada hacia Adelante",
                    "back": "Sensibilidad hacia Atrás",
                    "right": "Sensibilidad Ajustada a la Derecha",
                    "left": "Sensibilidad Magra Izquierda",
                    "scaleHigh": "Ligeramente Magro",
                    "scaleLow": "Grande Magro"
                },
                "duck": {
                    "title": "Sensibilidad de Cabeza Agachada/Levantada",
                    "description": "Estos valores determinan qué tan lejos debe agacharse o levantar la cabeza para activar los controles.",
                    "down": "Sensibilidad de Agacha",
                    "up": "Levántate la Sensibilidad",
                    "scaleHigh": "Ligero Turno",
                    "scaleLow": "Turno Grande"
                }
            },
            "face": {
                "title": "Sensibilidad a la Expresión Facial",
                "description": "La sensibilidad le dice a Cephable qué tan exagerada es una expresión que necesita para activar un control. Cuanto mayor sea el valor (más a la derecha en el control deslizante), mayor será la sensibilidad y, por lo tanto, menos necesitará moverse para activar el control.",
                "eyebrow": {
                    "title": "Sensibilidad de las Cejas",
                    "description": "Estos valores determinan cuánto debes levantar o bajar las cejas para activar los controles.",
                    "up": "Aumentar la Sensibilidad de las Cejas",
                    "scaleHigh": "Ligero Aumento",
                    "scaleLow": "Gran Aumento"
                },
                "mouth": {
                    "title": "Sensibilidad Bucal",
                    "description": "Estos valores determinan cuánto necesitas abrir o cerrar la boca para activar los controles.",
                    "open": "Sensibilidad de la Boca Abierta",
                    "close": "Sensibilidad de la Boca Cerrada",
                    "smile": "Sensibilidad de la Sonrisa",
                    "scaleHigh": "Ligeramente Abierto",
                    "scaleLow": "Abierto Grande",
                    "smileScaleHigh": "Leve Sonrisa",
                    "smileScaleLow": "Gran Sonrisa",
                    "closeScaleHigh": "Ligeramente Cerrado",
                    "closeScaleLow": "Bien Cerrado"
                }
            },
            "mouse": {
                "title": "Movimiento de la Cabeza para los Controles del Ratón",
                "description": "Determine si desea utilizar los controles de movimientos de la cabeza y cómo quiere mover el ratón en lugar de activar otras salidas.",
                "enable": {
                    "title": "Habilitar el Movimiento de la Cabeza para los Controles del Ratón",
                    "description": "Si esto está activado, algunos de los controles de movimiento de tu cabeza se usarán para mover el ratón en lugar de los controles de activación.",
                    "option": "¿Utiliza controles de cabeza para el movimiento del ratón?"
                },
                "input": {
                    "title": "Tipo de entrada del ratón",
                    "description": "Seleccione qué tipo de gestos con la cabeza desea asignar a los controles del ratón. Por ejemplo, Inclinar la cabeza significa que puede inclinar la cabeza hacia la izquierda y hacia la derecha para mover el ratón hacia la izquierda y hacia la derecha, Girar la cabeza significa que puede girar la cabeza hacia la izquierda y hacia la derecha para mover el ratón y Inclinar la cabeza significa que puede inclinarse hacia la izquierda y hacia la derecha para moverse tu ratón.",
                    "option": "Seleccionar tipo de entrada",
                    "optionLong": "Seleccione el tipo de movimiento de la cabeza que desea utilizar para controlar el ratón."
                },
                "invert": {
                    "title": "Invertir el Movimiento del Ratón",
                    "description": "Si esto está activado, la dirección en la que mueve la cabeza se invertirá respecto de la dirección en la que mueve el ratón. Para el eje X: si esto está activado, al moverlo hacia la izquierda se moverá el ratón hacia la derecha y si se mueve hacia la derecha lo moverá hacia la izquierda. Para el eje Y: si esto está activado, al moverlo hacia abajo, el ratón se moverá hacia arriba y al moverlo hacia arriba, lo moverá hacia abajo.",
                    "x": "¿Invertir el movimiento del ratón en el eje X?",
                    "y": "¿Invertir el movimiento del ratón en el eje Y?"
                },
                "mode": {
                    "title": "Modo de Movimiento del Ratón",
                    "description": "Selecciona cómo quieres que el cursor reaccione a los movimientos de tu cabeza."
                },
                "speed": {
                    "title": "Velocidad del ratón",
                    "description": "Determina la velocidad constante a la que quieres que se mueva el cursor.",
                    "fast": "Rápido",
                    "slow": "Lento"
                },
                "linear": {
                    "title": "Movimiento Lineal del Ratón",
                    "description": "Si esta opción está activada, el cursor solo se mueve en líneas rectas horizontales o verticales, lo que hace más fácil navegar en esas direcciones específicas sin ninguna desviación diagonal.",
                    "option": "¿Utilizar el movimiento lineal del ratón?"
                },
                "accelerationRate": {
                    "title": "Velocidad de Aceleración del Ratón",
                    "description": "Ajuste la velocidad con la que aumenta la velocidad del cursor cuanto más tiempo mantenga la cabeza quieta."
                },
                "accelerationCurve": {
                    "title": "Curva de Aceleración del Ratón",
                    "description": "Ajuste la velocidad a la que aumenta la velocidad del cursor en relación con el movimiento de la cabeza.",
                    "linear": "Lineal",
                    "exponential": "Exponencial",
                    "sublinear": "Sub-lineal"
                },
                "maximumSpeed": {
                    "title": "Velocidad Máxima del Ratón",
                    "description": "Determinar el número máximo de píxeles que el cursor puede moverse por segundo."
                },
                "steadyGlide": {
                    "title": "Deslizamiento Constante",
                    "description": "Cuando mueves la cabeza más allá de un punto determinado, el cursor se desliza continuamente en esa dirección a una velocidad constante."
                },
                "speedBoost": {
                    "title": "Aumento de Velocidad",
                    "description": "El cursor comienza a moverse más rápido cuanto más tiempo mantienes la cabeza en una posición. Cuanto más tiempo mantengas la cabeza quieta, más rápido se acelerará el cursor."
                },
                "dynamicGlide": {
                    "title": "Deslizamiento Dinámico",
                    "description": "La velocidad del cursor aumenta según cuánto mueves la cabeza. Cuanto más mueves la cabeza, más rápido se desliza el cursor."
                },
                "proportionalSpeed": {
                    "title": "Velocidad Proporcional",
                    "description": "El cursor sigue la punta de su nariz en proporción a las dimensiones de su pantalla."
                },
                "off": {
                    "title": "Apagado",
                    "description": "El movimiento del mouse está deshabilitado."
                },
                "disabled": "Esta función está deshabilitada para conexiones y extensiones remotas."
            }
        },
        "stop": "Detener la cámara",
        "show": "Mostrar cámara",
        "hide": "Ocultar cámara",
        "warn": "No se han iniciado los controles de la cámara. Inicie la cámara para permitir los controles de rostro y cuerpo.",
        "draw": {
            "error": "Error al cargar la señal de la cámara. Revisa tu cámara y vuelve a intentarlo."
        },
        "select": "Seleccione una cámara que desee emparejar para obtener controles mejorados usando su rostro, cuerpo y botones de acción rápida."
    },
    "microphone": {
        "windowTitle": "Controles de Voz Compatibles",
        "title": "Micrófono",
        "titlePlural": "micrófonos",
        "settings": "Configuración del Micrófono",
        "start": "Iniciar Micrófono",
        "stop": "Detener micrófono",
        "descriptionShort": "Permite comandos de voz y dictado.",
        "description": "Utilice tu micrófono incorporado para habilitar los controles de voz y el dictado.",
        "select": "Seleccione el micrófono que desee emparejar para obtener controles mejorados usando tu voz.",
        "empty": "No se encontraron micrófonos.",
        "search": "Buscar por nombre de micrófono",
        "manage": {
            "title": "Haga clic para ver y administrar los detalles de tus micrófonos.",
            "description": ""
        },
        "permission": {
            "title": "Permisos de micrófono requeridos",
            "description": "Debe darle permiso a Cephable para usar tu micrófono y usar los controles de voz.",
            "button": "Abrir configuración de permisos",
            "no": "Sin acceso al micrófono",
            "help": "Cephable necesita acceso a tu micrófono para usar los controles de voz. Navegue a <strong>Configuración del sistema</strong>  <strong>Privacidad</strong>  <strong>Micrófono</strong> y habilite Cephable para acceder a tu micrófono."
        },
        "controls": {
            "pause": "Pausar controles de voz",
            "paused": "Controles en pausa.",
            "resume": "Reanudar controles de voz",
            "dictationPlay": "Iniciar modo de dictado",
            "dictationPause": "Detener el modo de dictado",
            "prompt": "Empieza a hablar para ver tus controles de voz aquí...",
            "dictationPrompt": "Empieza a hablar para escribir lo que dices...",
            "latency": "Alta latencia detectada. Considere cerrar algunas aplicaciones que podrían estar consumiendo demasiados recursos.",
            "noDeviceConnectedDescription": "El control del micrófono sirve como vista previa de la interfaz. Ningún paso se ejecutará exitosamente. Conecte este dispositivo complementario a otro para iniciar comandos.",
            "status": {
                "paused": "En pausa.",
                "dictating": "Dictando.",
                "optimistic": "Optimista:",
                "listening": "Escuchando:",
                "loadingModel": "Cargando modelo de voz...",
                "thinking": "Pensamiento...",
                "loadingPhiModel": "Cargando modelo de generación de texto...",
                "generatingText": "Generando...",
                "preparingPhiModel": "Preparando modelo de generación de texto...",
                "permission": "Comprobando permisos del micrófono...",
                "typing": "Mecanografía..."
            },
            "loadingDetail": "Esto puede tardar unos minutos.",
            "generatingTextDetail": "Detenga la generación cambiando las aplicaciones o diciendo \"deje de generar\""
        },
        "edit": {
            "title": "Editar la Configuración del Micrófono",
            "autoStart": {
                "title": "Iniciar Micrófono Automáticamente",
                "option": "¿Inicio automático de micrófono y controles de voz?",
                "description": "Con esta configuración activada, su dispositivo de entrada activará los micrófonos y empezará a procesar los controles de voz al iniciarse, después de conectarlo o encenderlo. Si está desactivada, debe pulsar el botón \"Comenzar a escuchar\" en la página de conexión."
            },
            "optimistic": {
                "title": "Controles de Voz Optimistas",
                "option": "¿Utiliza controles de voz optimistas?",
                "description": "Cephable tiene dos modos de sensibilidad para los controles de voz: Estándar y Optimista. El modo Estándar permite a Cephable reconocer todas las palabras que comprende y se puede usar con el modo de dictado. El modo Optimista le indica a Cephable que se centre más en los controles de voz de la aplicación. Con el modo Optimista activado, los controles de voz se activarán más rápido, pero también podrías activarlos accidentalmente si no dices la palabra exacta. El modo Optimista no permite el dictado."
            },
            "confirm": {
                "title": "Tiene cambios sin guardar.",
                "description": "Se detectaron cambios sin guardar. ¿Desea guardarlos antes de salir?"
            },
            "aiCommands": {
                "title": "Comandos de voz inteligentes",
                "description": "Los comandos de voz inteligentes permiten que la IA de Cephable prediga los comandos de voz que intentas usar sin necesidad de que coincidan exactamente. Esto te permite indicarle a tu computadora qué hacer de forma más natural y Cephable te ayuda a descifrarlo.",
                "option": "¿Utilizar comandos de voz inteligentes?"
            },
            "aiDictation": {
                "title": "Dictado inteligente y escritura rápida",
                "description": "Dictado Inteligente y Escritura Rápida ofrecen la experiencia de escritura más precisa disponible. Dictado gestiona automáticamente la puntuación, los nombres propios y la estructura de las oraciones, mientras que Escritura Rápida proporciona predicciones y correcciones inteligentes que te ayudan a escribir con facilidad y precisión.",
                "option": "¿Cómo utilizar Dictado inteligente y Escritura rápida?"
            },
            "description": "Administre sus comandos de voz y configuraciones de dictado para esta conexión."
        },
        "warn": "El micrófono no se ha activado. Activa el micrófono para permitir comandos de voz y dictado.",
        "devices": {
            "error": "Dispositivo de entrada de micrófono no encontrado."
        },
        "startDescription": "Encienda el micrófono para comenzar a escuchar los comandos."
    },
    "localization": {
        "title": "Preferencias de Idioma",
        "titleShort": "El Idioma",
        "description": "Elija tu idioma preferido de una lista de idiomas admitidos.",
        "newUserDescription": "Seleccione un idioma preferido antes de continuar.",
        "edit": "Actualizar Prefencias de Idioma",
        "display": {
            "title": "Idioma de la pantalla",
            "description": "Idioma que se muestra al usar Cephable. Esto incluye elementos como menús, notificaciones y controles de aplicaciones, que se muestran en el idioma que prefieras."
        },
        "voice": {
            "title": "Idioma de control de voz",
            "description": "Este es el idioma que se utiliza al reconocer dictados y comandos de voz. Especificar el idioma mejora la precisión de tus entradas de voz.",
            "settings": {
                "title": "Reconocimiento de Voz e Idioma de Pantalla",
                "description": "Ajuste la configuración de idioma tanto para la pantalla como para los controles de voz. Esta opción le permite seleccionar tus idiomas preferidos para las interacciones de texto y micrófono en pantalla, como controles de voz y dictado."
            }
        },
        "locales": {
            "en": "English — Inglés",
            "en-us": "English (US) — Inglés (Estados Unidos)",
            "es": "Español",
            "fr": "Français — Francés",
            "it": "Italiano — Italiano",
            "de": "Deutsch - Alemán",
            "ja": "日本語 - Japonés",
            "en-gb": "English (UK) - Inglés (Reino Unido)",
            "en-in": "English (India) - Inglés (India)"
        },
        "save": {
            "success": "¡Preferencias de idioma guardadas!",
            "error": "Error al guardar las preferencias de idioma"
        },
        "profile": {
            "view": "Variantes",
            "title": "Idioma de control de la aplicación",
            "question": "¿Qué idioma de control de la aplicación te gustaría editar?",
            "description": "Algunos controles de la aplicación tienen variantes para diferentes idiomas. Cambia a otro idioma para editar y personalizar.",
            "change": "Cambiar idioma"
        },
        "unsupported": {
            "title": "Idioma no compatible {{locale}}",
            "description": "El idioma seleccionado no es compatible. Elija otro idioma."
        },
        "select": "Seleccionar idioma",
        "localesShort": {
            "en": "Inglés",
            "en-us": "Inglés (EE. UU.)",
            "es": "Español",
            "fr": "Francés",
            "it": "italiano",
            "de": "Alemán",
            "ja": "japonés"
        }
    },
    "mobileApp": {
        "title": "Aplicación móvil"
    },
    "skipToMain": "Saltar al Contenido Principal",
    "dashboard": {
        "title": "Panel"
    },
    "developer": {
        "title": "Revelador",
        "titleLong": "Recursos para desarrolladores",
        "description": "Cephable se puede integrar directamente en su aplicación, juego o servicio utilizando nuestros SDK.",
        "sdk": {
            "title": "Explora nuestros SDK",
            "description": "Ofrecemos SDK de primera clase diseñados para integrar sin problemas el reconocimiento de voz y los controles adaptativos en sus aplicaciones. Nuestras herramientas están diseñadas para mejorar la interacción del usuario a través de controles intuitivos y fomentar la accesibilidad, lo que garantiza que todos los usuarios puedan utilizar su software de manera más eficaz.",
            "javascript": {
                "title": "JavaScript",
                "subtitle": "Web",
                "description": "Integre controles de voz y adaptativos directamente en sus aplicaciones web.",
                "action": "Obtener el Paquete NPM"
            },
            "net": {
                "title": ".NET",
                "subtitle": "Aplicaciones de Windows",
                "description": "Aproveche el poder de .NET para crear aplicaciones con nuestros SDK WPF y WinUI3.",
                "actionCore": "Obtener el Paquete básico",
                "actionWpf": "Obtener el Paquete WPF"
            },
            "android": {
                "title": "Androide",
                "subtitle": "Dispositivos móviles",
                "description": "Aplicaciones de Android diseñadas para facilitar las capacidades de voz y movimiento de la cabeza.",
                "action": "Obtener el SDK de Android"
            },
            "more": {
                "title": "Más",
                "description": "¿No encuentras lo que necesitas? Contáctanos y te ayudaremos.",
                "action": "Solicitar un SDK"
            }
        },
        "demo": {
            "title": "Población",
            "titleLong": "Experimente nuestros SDK en acción",
            "description": "Descubra el poder de nuestras tecnologías de control de voz y movimiento de la cabeza a través de nuestras aplicaciones de muestra. Desde juegos interactivos hasta aplicaciones web y móviles dinámicas, cada ejemplo demuestra la versatilidad y la eficacia de nuestros SDK. Explore estos ejemplos para obtener información e inspiración para integrar una accesibilidad mejorada y experiencias inmersivas en sus propios proyectos.",
            "game": {
                "title": "Juego 2048",
                "subtitle": "Web",
                "description": "Mejora el juego tradicional con controles adaptables de voz y movimiento de cabeza.",
                "action": "Juega el juego"
            },
            "unity": {
                "title": "Unidad",
                "subtitle": "Desarrollo de juegos",
                "description": "Vea cómo se pueden aprovechar los controles adaptativos en los juegos para brindar una experiencia de usuario más atractiva.",
                "action": "Obtenga la muestra"
            },
            "samples": "Demostraciones y muestras",
            "other": {
                "title": "Otras demostraciones",
                "description": "Experimente de primera mano cómo Cephable puede mejorar su aplicación, juego o dispositivo.",
                "action": "Ver más demostraciones"
            },
            "web": {
                "title": "Ejemplos de SDK web",
                "subtitle": "Web",
                "description": "Integración sencilla de toda nuestra funcionalidad principal en aplicaciones web.",
                "action": "Experimente el SDK"
            }
        },
        "other": {
            "title": "Otros recursos",
            "description": "Si no encuentra lo que necesita en nuestros SDK, intente trabajar directamente con nuestras API o comuníquese con la comunidad para obtener ayuda, inspiración y soporte.",
            "api": {
                "title": "API",
                "description": "Nuestras API le permiten interactuar con Cephable directamente. Puede usar nuestras API para crear integraciones personalizadas."
            },
            "support": {
                "title": "Apoyo",
                "description": "¿No encuentras lo que necesitas? Ponte en contacto con nuestra comunidad a través de Discord.",
                "action": "Únete a Discord"
            }
        }
    },
    "invalidNumber": "N/A",
    "upgrade": "Mejora",
    "license": {
        "trial": {
            "subtitle": "Puedes invitar a {{count}} colegas a probar Cephable contigo.",
            "noUsersSubtitle": "No tienes usuarios de prueba restantes. Actualiza a una licencia paga para agregar más usuarios.",
            "expired": {
                "user": "Su actualización gratuita a {{productName}} vence el {{date}}. Para actualizar, contacte con el administrador de su organización: {{admin}}.",
                "admin": "Su actualización gratuita a {{productName}} vence el {{date}}.",
                "userLong": "Parece que tu actualización gratuita a {{productName}} ha expirado. Para actualizar, contacta con el administrador de tu organización: {{admin}}.",
                "adminLong": "Parece que tu actualización gratuita a {{productName}} ha expirado. Puedes actualizar tu licencia para seguir accediendo a funciones avanzadas que no están disponibles en Cephable Basic."
            },
            "start": "Comience una prueba gratuita",
            "title": {
                "single": "Se le ha actualizado a {{productName}} de forma gratuita con {{days}} días restantes",
                "multiple": "{{organization}} está en una prueba gratuita con {{days}} días restantes"
            },
            "upgrade": "Al actualizar, mantenga su acceso a funciones como controles de voz mejorados, tareas inteligentes de IA y muchos controles de aplicaciones prediseñados."
        },
        "required": {
            "title": "Se requiere licencia profesional de Cephable",
            "description": "Parece que estás usando Cephable Basic, que no es compatible con el uso comercial de Cephable. Actualiza a una licencia profesional para seguir usando la aplicación."
        },
        "upgrade": {
            "professional": "Actualización a la Licencia Profesional de Cephable",
            "generic": {
                "title": "Mejora tu experiencia con Cephable",
                "description": "La plataforma Cephable ofrece diferentes productos para uso comercial en el trabajo, la escuela o integrados en soluciones nativas."
            },
            "fallback": {
                "title": "Error al cargar el portal de facturación",
                "description": "No se puede cargar el portal de facturación. Haga clic en el botón a continuación para comunicarse con sales@cephable.com y continuar con la actualización."
            }
        },
        "activate": {
            "question": "¿Ya tienes una clave de licencia?",
            "button": "Activar",
            "title": "Activa Clave de Licencia",
            "description": "Ingresa tu clave de licencia para actualizar Cephable. Si no tienes una, inicia una prueba gratuita o compra una licencia.",
            "fieldLabel": "Clave de Licencia",
            "placeholder": "NkmurBfZzFrmm9Kx",
            "success": "¡Felicitaciones! ¡Su cuenta ha sido actualizada a {{license}}!",
            "invalid": {
                "key": "Clave no válida. Asegúrese de haber ingresado la clave correcta.",
                "empty": {
                    "key": "Clave no válida. Asegúrese de haber ingresado un valor.",
                    "name": "Nombre de organización no válido. Asegúrese de haber ingresado un valor."
                }
            },
            "descriptionLong": "Ingresa tu clave de licencia para actualizar Cephable. Si no tienes una, inicia una prueba gratuita o compra una licencia."
        },
        "welcome": {
            "title": "Bienvenido a {{license}}.",
            "description": "Te has unido a {{organization}} con éxito. {{description}}"
        },
        "redirect": {
            "title": "Redireccionando",
            "description": "Se le ha redirigido a un portal de facturación externo. Se abrirá una nueva pestaña en su navegador. Si no se le redirige en unos segundos, haga clic en el botón que aparece a continuación.",
            "error": "Error de redirección de facturación",
            "external": "Redirigido. Por favor, revise su navegador."
        },
        "key": {
            "title": "Clave de licencia",
            "titlePlural": "Claves de licencia",
            "description": "Una clave de licencia es un identificador único que se utiliza para otorgar acceso a las funciones profesionales, educativas o para desarrolladores de Cephable.",
            "details": "Detalles de la clave de licencia",
            "assigned": "Usado el: {{date}}",
            "expires": "Caduca el: {{date}}",
            "assign": "Asignar clave a nueva organización",
            "error": "Error al cargar la clave de licencia.",
            "empty": {
                "title": "No se encontraron claves de licencia.",
                "description": "Parece que no hay claves de licencia que coincidan con estos criterios o que aún no ha adquirido una clave de licencia."
            },
            "product": {
                "title": "Compra",
                "titleLong": "Comprar claves de licencia",
                "description": "Adquiera una clave de licencia para aprovechar todo el potencial de Cephable. Vea los diferentes planes y opciones de precios disponibles.",
                "action": "Comprar ahora",
                "empty": {
                    "title": "No se encontraron productos.",
                    "description": "Parece que no tienes ningún producto. Ponte en contacto con nuestro equipo de ventas o con tu representante para que te ayudemos a resolver este problema."
                },
                "yearly": "Facturación anual",
                "years": "Facturado cada {{value}} años",
                "days": "Facturado cada {{value}} días",
                "Subscription": {
                    "title": "Suscripción"
                },
                "MeteredConsumption": {
                    "title": "Consumo medido"
                },
                "PayDown": {
                    "title": "Pagar al contado"
                },
                "OneTime": {
                    "title": "Una vez"
                }
            }
        },
        "pro": {
            "tag": "Pro",
            "detail": "Esta es una función exclusiva de Cephable Professional",
            "requiredDetail": "Se requiere una licencia profesional de Cephable para esta función. Puede actualizarla o iniciar una prueba gratuita en la configuración de su cuenta."
        },
        "titlePlural": "Licencias"
    },
    "purchase": "Compra",
    "saveError": "Error al guardar los cambios.",
    "description": "Descripción",
    "expand": "Expandir",
    "expandMenu": "Expandir menú",
    "editor": {
        "title": "Editor de Markdown",
        "bold": "Atrevido",
        "italic": "Itálico",
        "underline": "Subrayar",
        "hr": "Regla horizontal",
        "link": "Enlace",
        "quote": "Cita",
        "code": "Código",
        "codeBlock": "Bloque de código",
        "comment": "Comentario",
        "image": "Imagen",
        "table": "Mesa",
        "unordered-list": "Lista desordenada",
        "ordered-list": "Lista ordenada",
        "checked-list": "Lista de comprobación",
        "help": "Ayuda",
        "edit": "Editar",
        "live": "Vivir",
        "preview": "Avance",
        "fullscreen": "Pantalla completa",
        "placeholder": "Por favor ingrese el texto de Markdown aquí...",
        "strikethrough": "Tachado"
    },
    "created": "Creado: {{value}}",
    "updated": "Actualizado: {{value}}",
    "deleted": "Eliminado: {{value}}",
    "expires": "Caduca: {{value}}",
    "expired": "Vencido: {{value}}",
    "used": "Usado: {{value}}",
    "results": "Resultados",
    "panel": {
        "title": "Panel Cefaleable",
        "question": "¿Panel de inicio automático?",
        "position": {
            "top": "Arriba",
            "right": "Bien",
            "left": "Izquierda",
            "bottom": "Abajo ",
            "description": "Seleccione dónde desea que aparezca el Panel Cephable en su pantalla.",
            "label": "Posición"
        },
        "sections": {
            "description": "Elige qué secciones del panel son visibles. Puedes ocultarlas según tus preferencias para aprovechar al máximo el espacio del panel.",
            "microphone": "Controles de micrófono y voz",
            "camera": "Controles de cámara y rostro/cabeza",
            "profile": "Controles y vistas previas de la aplicación",
            "globalControls": "Controles globales y de dispositivos",
            "tasks": "Tareas inteligentes",
            "buttons": "Botones de acción rápida"
        },
        "titleShort": "Panel",
        "description": "Este es el panel que funciona como centro de control principal. Siempre está visible y te permite controlar tus aplicaciones con la voz, entre otras funciones."
    },
    "resume": "Reanudar",
    "textGeneration": {
        "settings": "Configuración de generación de texto",
        "edit": {
            "title": "Editar la configuración de generación de texto",
            "description": "Puede refinar la configuración de Generación de texto inteligente para crear los mejores resultados para usted.",
            "autoStart": {
                "title": "Generación de texto de calentamiento automático",
                "description": "Con esta configuración activada, Cephable AI preparará automáticamente los modelos de IA utilizados para la generación de texto. Esto acelerará su rendimiento al usar comandos de generación, pero consumirá más recursos del equipo. Desactivar esta configuración ahorrará recursos, pero puede ralentizar la generación de texto.",
                "option": "¿Modelos de IA de generación de texto de calentamiento automático?"
            },
            "prompt": {
                "title": "Información adicional para la generación de texto",
                "description": "Introduce información adicional para usarla con la IA de Cephable para generar texto. Usa este campo para especificar tus preferencias de tono, estilo de escritura o cualquier otro detalle.",
                "field": "Aviso adicional",
                "placeholder": "Por ejemplo, usa un tono amable, escribe con profesionalismo, sé conciso y directo. Al escribir código, deja comentarios reflexivos, pero no demasiados, etc."
            },
            "enableTextGen": {
                "title": "Habilitar la generación de texto inteligente",
                "description": "Con esta configuración activada, Cephable AI podrá usar el control del dispositivo de generación de texto para generar texto en cualquier aplicación. Desactivarla deshabilitará este comando.",
                "option": "¿Utilizar generación de texto inteligente?"
            },
            "terminate": {
                "title": "Recursos para la generación de texto claro",
                "description": "Haz clic para borrar los recursos utilizados para la generación de texto. Esto liberará recursos en tu computadora, pero podría ralentizar la generación de texto la próxima vez que la uses.",
                "button": "Recursos claros",
                "success": "Limpieza de recursos de generación de texto.",
                "confirm": {
                    "title": "Recursos para la generación de texto claro",
                    "description": "¿Seguro que desea borrar los recursos utilizados para la generación de texto? Esto liberará recursos en su computadora, pero podría ralentizar la generación de texto la próxima vez que la use.",
                    "confirm": "Sí, recursos claros",
                    "cancel": "Cancelar"
                }
            },
            "clearModelCache": {
                "title": "Borrar caché del modelo de IA",
                "description": "Seleccione qué caché del modelo de IA desea borrar y volver a descargar. Esto liberará espacio de almacenamiento en su ordenador y volverá a descargar los archivos del modelo seleccionado.",
                "button": "Borrar y volver a descargar",
                "success": "Se eliminaron archivos de modelo local.",
                "confirm": {
                    "title": "Borrar y volver a descargar la caché del modelo de IA",
                    "description": "¿Está seguro de que desea borrar la caché del modelo de IA seleccionado y eliminar los archivos de su sistema? Los modelos seleccionados se volverán a descargar automáticamente.",
                    "confirm": "Sí, borrar y volver a descargar.",
                    "cancel": "Cancelar",
                    "textGenLabel": "Text Generation (Inference) model",
                    "workflowsLabel": "AI Workflows models"
                },
                "error": "Error al eliminar archivos del modelo local."
            },
            "enableHistory": {
                "title": "Habilitar el historial de generación de texto",
                "description": "Con esta configuración activada, Cephable AI utilizará su historial de generación de texto para generar texto con el contexto de su acción anterior.",
                "option": "¿Utilizar el historial de generación de texto?"
            }
        },
        "prompt": {
            "systemPrompt": "Genere SOLO el texto solicitado: sin explicaciones, comentarios ni texto superfluo. Sin Markdown ni explicaciones espontáneas. Para el código, genere solo código sin formato: sin restricciones, etiquetas de idioma ni explicaciones.",
            "appName": "Actualmente estás generando texto para {{appName}}.",
            "userPreferences": "Respete estas preferencias de usuario sobre cómo quieren que se genere el texto: {{userPreferences}}."
        },
        "rewritePrompt": {
            "systemPrompt": "Reescriba o reformatee el texto proporcionado según las instrucciones. Si se reformatea (por ejemplo, listas, tablas, cambios de estructura), conserve exactamente las palabras originales. Si se reescribe (por ejemplo, tono, estilo, extensión), conserve el significado, pero no necesariamente las palabras. Imprima SOLO el resultado, sin explicaciones ni comentarios. Esto puede ser parte de un documento más extenso. Imprima solo el resultado sin encabezados, etiquetas ni preámbulos.",
            "userPreferences": "Respete estas preferencias de usuario sobre cómo quieren que se genere el texto: {{userPreferences}}.",
            "rewriteInstructions": "Instrucciones: {{rewriteInstructions}}."
        },
        "translatePrompt": {
            "systemPrompt": "Traduce el siguiente texto a {{language}}. Imprime SOLO el texto traducido. Sin explicaciones, preámbulos, formato Markdown ni restricciones de código. Conserva el formato. Para el código: traduce solo comentarios y cadenas, conservando la sintaxis con precisión.",
            "userPreferences": "Respete estas preferencias de usuario sobre cómo quieren que se genere el texto: {{userPreferences}}.",
            "genericUserPrompt": "Traducir: {{userRequestText}}"
        },
        "disabled": {
            "title": "Las tareas inteligentes están deshabilitadas",
            "description": "Parece que has desactivado las tareas inteligentes. Actualiza para desbloquear la generación de texto, la reescritura y más en tu configuración."
        },
        "summarizePrompt": {
            "systemPrompt": "Resuma el texto proporcionado de forma concisa. Puede formar parte de un documento más extenso. Imprima SOLO el resumen, sin preámbulo, etiquetas ni explicaciones.",
            "userPreferences": "Respete estas preferencias de usuario sobre cómo desea que se genere el texto: {{userPreferences}}.",
            "userPrompt": "Resumir: {{userRequestText}}"
        }
    },
    "profile": {
        "title": "Controles de la aplicación",
        "titlePlural": "Controles de la aplicación",
        "titlePreview": "Vista previa de los controles",
        "previous": "Controles de aplicaciones anteriores",
        "manage": "Administrar controles de aplicaciones",
        "view": "Controles de vista",
        "edit": "Editar controles de la aplicación",
        "add": "Agregar controles de aplicación",
        "create": "Crear controles de aplicación",
        "warn": "La cámara o el micrófono deben estar iniciados para poder usar los controles de la aplicación.",
        "descriptionShort": "Descubra las diferentes formas en que Cephable le ayuda a controlar sus dispositivos y software.",
        "name": "Nombre de la aplicación",
        "nameQuestion": "¿Cómo quieres llamar a estos controles de la aplicación?",
        "newName": "Nuevos controles de la aplicación",
        "search": "Buscar controles de aplicaciones por nombre",
        "searchLong": "Buscar controles de aplicaciones por nombre o descripción",
        "keyboardAndMouse": "Teclado y ratón",
        "genericController": "Mando de gamepad",
        "keyboardMouseAndController": "Teclado, ratón y controlador",
        "permissionError": "No tienes permiso para usar estos controles de la aplicación.",
        "set": {
            "title": "Parece que aún no tienes configurados los controles de la aplicación.",
            "cta": "Establecer controles de la aplicación",
            "empty": {
                "auto": "Cambiar a otra aplicación para ver los controles",
                "select": "Seleccione un control para comenzar",
                "none": "No se encontraron controles de aplicación"
            },
            "description": "Los controles de la aplicación permiten a Cephable saber qué detectar y qué acciones realizar. Puedes cambiar los controles de la aplicación cuando quieras desde la página de inicio o en la configuración de tu conexión."
        },
        "summary": {
            "title": "Resumen de los controles de la aplicación",
            "descriptionLong": "Aquí tienes los detalles de estos controles de la aplicación. Puedes buscar controles, acciones y más para ver qué puedes hacer con ellos.",
            "description": "Obtenga un resumen de estos controles de la aplicación, incluidos qué controles hay, personalizaciones, detalles y más.",
            "view": "Ver resumen de controles de la aplicación",
            "filter": "Filtrar por tipo de entrada",
            "placeholder": "Buscar nombres de controles..."
        },
        "copy": {
            "title": "Copiar controles de la aplicación",
            "duplicate": "Controles de aplicaciones duplicados",
            "question": "¿Crear una copia?",
            "description": "¿Quieres crear una copia de estos controles de la aplicación? Se abrirá una nueva ventana con los controles copiados, pero no se añadirá a tu cuenta hasta que la guardes.",
            "confirm": "Sí, crea una copia",
            "profileSuffix": "{{name}} (copia)"
        },
        "new": {
            "title": "Crear nuevos controles de aplicación",
            "description": "Crea controles desde cero o deja que la IA de vanguardia genere controles personalizados, lo que te permitirá navegar por aplicaciones y software sin esfuerzo usando tu voz, cabeza y gestos faciales.",
            "note": "Recomendado para usuarios avanzados.",
            "scratch": "Crear desde cero"
        },
        "advancedOptions": "Opciones de control avanzadas",
        "delete": {
            "title": "Eliminar controles de la aplicación",
            "titleLong": "Eliminar estos controles de la aplicación",
            "description": "Puede eliminar estos controles de aplicación haciendo clic en \"Eliminar controles de aplicación\".",
            "confirm": "¿Estás seguro de que deseas eliminar estos controles de la aplicación?",
            "confirmLong": "Una vez que elimines estos controles de la aplicación, no podrás volver a ellos. ¿Estás seguro de que quieres eliminarlos?",
            "confirmButton": "Sí, elimine estos controles de la aplicación"
        },
        "current": "Controles actuales",
        "loading": "Controles de carga...",
        "null": "Aún no tienes controles de aplicación. Haz clic abajo para crear uno.",
        "nullButton": "Crea tus primeros controles de aplicación",
        "preview": "Avance",
        "features": "Características",
        "byline_public": "Por: Equipo Cephable",
        "byline_shared": "Compartido por: Comunidad Cephable",
        "share": {
            "title": "Controles de la aplicación para compartir",
            "previewTitle": "Vista previa de los controles de aplicaciones compartidas",
            "description": "¡Comparte estos controles de aplicación con otros para que puedan obtener una copia y personalizarlos desde allí!",
            "descriptionLong": "Comparte estos controles de la aplicación para que puedan obtener una copia y personalizarlos desde ahí. Elige cómo quieres compartirlos y crea un enlace para enviarlos.",
            "add": "Crear un enlace para compartir",
            "confirm": "Comparte esta URL",
            "link": "Compartir enlace",
            "copy": "Copiar enlace",
            "copied": "¡Copiado!",
            "usage": "Cantidad de uso",
            "created": "Creado {{value}}",
            "expiration": {
                "title": "Vencimiento",
                "once": "Solo se permite un uso",
                "unlimited": "Permitir uso ilimitado",
                "no": "Sin vencimiento",
                "date": "Fecha de expiración",
                "dateDescription": "Caduca en una fecha específica"
            },
            "manage": "Administrar enlaces compartidos anteriores",
            "empty": "No se han creado recursos compartidos para estos controles de aplicación."
        },
        "swap": {
            "title": "Controles de intercambio",
            "titleLong": "Intercambia los controles de tu aplicación",
            "descriptionShort": "Utilice diferentes controles de aplicación para que coincidan con el programa o software que está utilizando.",
            "description": "Puede alternar entre diferentes controles de aplicaciones para que coincidan con el programa o software que esté utilizando."
        },
        "autoProfileSwitching": {
            "title": "Conmutación automática de control",
            "alerts": {
                "disabled": "El cambio automático de control está desactivado.",
                "temporarilyDisabled": "El cambio automático de control está desactivado temporalmente.",
                "enabled": "El cambio de control automático está activado.",
                "error": "Error al guardar las preferencias de cambio de control automático"
            },
            "associatedPrograms": {
                "add": "Agregar un nuevo programa asociado",
                "description": {
                    "personal": "Seleccione el software o los programas que desea conectar a estos controles. Esto permite el cambio automático de controles, donde Cephable cambiará automáticamente los controles de la aplicación para que coincidan con el programa que esté usando.",
                    "short": "Elija el software o programas que desea conectar a estos controles."
                },
                "edit": "Editar programas asociados",
                "noOptionsText": "Comience a escribir para encontrar programas asociados",
                "profileLabel": "Controles de la aplicación:",
                "remove": "Eliminar programa asociado",
                "title": "Programas asociados",
                "when": "Cephable cambiará automáticamente los controles de mi aplicación a {{profileName}} cuando use...",
                "emptySearch": "No hay programas asociados a estos controles.",
                "error": "Error al guardar los programas asociados. Inténtalo de nuevo más tarde.",
                "emptyError": "Se detectó un programa asociado vacío, elimínelo antes de continuar."
            },
            "commandOverlay": {
                "command": "Cambiar los controles de la aplicación: {{value}}"
            },
            "description": "El cambio automático de controles permite que Cephable se adapte a tu flujo de trabajo sin problemas. Al activarlo, Cephable ajustará los controles de tu app según el programa o software que uses. Si lo desactivas, puedes cambiar manualmente los controles de la app con el botón \"Intercambiar controles\" o con comandos globales."
        },
        "error": {
            "noMatch": "No hay controles de aplicación que coincidan con tu búsqueda.",
            "load": "Error al cargar los controles de la aplicación.",
            "add": "Error al agregar controles de la aplicación.",
            "delete": "Error al eliminar los controles de la aplicación.",
            "audioEventsWithEmptyCommands": "Faltan controles en tu respuesta. Revisa los controles para asegurarte de que estén completos.",
            "conflicts": "Error al guardar los controles de la aplicación debido a conflictos.",
            "save": "Error al guardar los controles de la aplicación. Inténtalo de nuevo.",
            "device": "Control de aplicación no válido para esta conexión. Prueba con otro."
        },
        "conflictIndicators": {
            "errorTitle": "Error al guardar los controles de la aplicación debido a conflictos",
            "warningTitle": "Controles de la aplicación guardados con advertencias",
            "subtitle": "Los controles de la aplicación que creaste tienen algunas configuraciones que pueden entrar en conflicto.",
            "profileNameErrors": "Conflicto de nombres en los controles de la aplicación",
            "emptyControlsMapped": "Nombres de entrada vacíos",
            "emptyControlsMappedDescription": "Agregue un comando de voz, expresión facial, inclinación de cabeza u otro comando a su entrada.",
            "emptyKeybindingControlsMapped": "Nombres de entrada vacíos para las combinaciones de teclas",
            "emptyKeybindingControlsMappedDescription": "Agregue un comando de voz, expresión facial, inclinación de cabeza u otro comando a su entrada para las combinaciones de teclas.",
            "duplicateNameTitle": "Nombre de controles de aplicación duplicados",
            "duplicateNameDescription": "Tienes controles de aplicación con el mismo nombre. Cámbialo antes de continuar.",
            "emptyNameTitle": "Nombre de controles de aplicación vacíos",
            "emptyNameDescription": "Los controles de la aplicación deben tener un nombre, por ejemplo, Juego 1, Spotify, Palabra, etc.",
            "macrosReleaseKeysMissingTitle": "Salidas con claves no liberadas",
            "macrosReleaseKeysMissingDescription": "Agregue una clave de liberación o detenga todos los pasos para evitar que las claves se atasquen.",
            "duplicateInputCommandMacroTitle": "Entradas de control idénticas",
            "duplicateCommandsDescription": "Elimine o cambie los comandos de entrada duplicados.",
            "duplicateInputCommandBindingsTitle": "Entradas de control idénticas para combinaciones de teclas",
            "conflictIndicatorDisplayString": "{{container}}: {{commandOrKeyName}} con {{commandOrEventType}}",
            "duplicateMacroNames": "Nombres de control duplicados",
            "duplicateMacroNamesDescription": "Elimine o cambie uno de sus nombres de control idénticos.",
            "warningIgnore": "Ignorar",
            "warningDoNotShowAgain": "No volver a mostrar advertencias",
            "macrosVoiceCommandConflictWithDictationTitle": "Controlar los comandos de voz igual que las palabras clave de dictado",
            "keybindingsVoiceCommandConflictWithDictationTitle": "Combinaciones de teclas: comandos de voz iguales que las palabras clave de dictado",
            "macrosVoiceCommandConflictWithDictationDescription": "Tus entradas de voz activarán el dictado y los comandos de voz.",
            "keybindingsVoiceCommandConflictWithDictationDescription": "Tus entradas de voz activarán el dictado y las pulsaciones de teclas.",
            "macrosVoiceCommandConflictWithGenerationTitle": "Los comandos de voz de control son los mismos que las palabras clave de generación",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "Las combinaciones de teclas de los comandos de voz son las mismas que las palabras clave de generación",
            "macrosVoiceCommandConflictWithGenerationDescription": "Tus entradas de voz activarán la generación y los comandos de voz.",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "Tus entradas de voz activarán la generación y las pulsaciones de teclas.",
            "duplicateAssociatedProgramNames": "Nombres de programas asociados duplicados",
            "duplicateAssociatedProgramNamesDescription": "Elimine o cambie uno de sus programas asociados idénticos.",
            "emptyEvent": {
                "title": "Pasos faltantes",
                "description": "Faltan pasos en tus controles. Esto podría provocar que Cephable no realice una acción al dar una orden."
            },
            "warningDetails": "Ver todos los conflictos"
        },
        "success": {
            "save": "Controles de la aplicación guardados.",
            "add": "Se agregaron controles de aplicación.",
            "delete": "Controles de la aplicación eliminados.",
            "share": "Enlace compartido creado y copiado al portapapeles",
            "shareDelete": "Enlace compartido eliminado.",
            "generate": "Controles de aplicación generados."
        },
        "warning": "Controles de la aplicación guardados con advertencias",
        "customize": "Personalizar los controles de la aplicación",
        "custom": "{{name}} (Personalizado)",
        "description": "Los controles de la aplicación son un conjunto de controles que puedes usar para controlar tu dispositivo o conexión. Puedes crear varios controles de la aplicación y alternar entre ellos cuando quieras."
    },
    "publicProfiles": {
        "toolbar": "Explorar los controles de la aplicación",
        "title": "Explorar los controles de la aplicación",
        "offline": {
            "title": "No se pueden cargar los controles de la aplicación pública",
            "description": "Parece que no tienes conexión. Puedes seguir usando los controles de tu aplicación, pero no podrás cargar nuevos controles públicos.",
            "confirm": "Bueno"
        },
        "announcement": "Se han cargado {{count}} nuevos controles de aplicación",
        "description": {
            "personal": "Los controles públicos de aplicaciones están disponibles para ayudarte a empezar a usar Cephable rápidamente en tus aplicaciones favoritas. Puedes usar los controles predeterminados, personalizarlos según tus necesidades o crear controles de aplicación completamente nuevos y personalizados desde cero.",
            "pro": "Los controles públicos de aplicaciones están disponibles para ayudarte a empezar a usar Cephable rápidamente en tus aplicaciones favoritas. Puedes usar los controles predeterminados, personalizarlos según tus necesidades o crear controles personalizados completamente nuevos mediante el generador de controles."
        },
        "team": "Equipo Cephable"
    },
    "publicTag": "Público",
    "tray": {
        "panel": "Panel de alternancia",
        "dashboard": "Mostrar panel de control",
        "quit": "Salir de Cephable"
    },
    "generate": "Generar",
    "stop": "Detener",
    "clear": "Claro",
    "rewrite": "Volver a escribir",
    "translate": "Traducir",
    "smartTasks": {
        "title": "Tareas inteligentes",
        "show": "Mostrar tareas inteligentes",
        "description": "Las tareas inteligentes son las diferentes tareas que la IA de Cephable puede realizar por ti. Estas tareas, impulsadas por la IA del dispositivo, permiten crear texto, resumir, reescribir, traducir, tomar notas y chatear con documentos.",
        "generateText": {
            "title": "Generar texto",
            "description": "Crea contenido de texto basado en tus aportaciones o indicaciones.",
            "label": "Describe lo que quieres generar"
        },
        "summarizeText": {
            "title": "Resumir texto",
            "description": "Condensar un texto extenso en un resumen conciso.",
            "directions": "Ingrese el texto a resumir, o Cephable utilizará automáticamente el texto que haya resaltado.",
            "titleShort": "Resumir",
            "write": "Escribir resumen",
            "label": "Introduzca texto para resumir",
            "outputLabel": "Tu resumen se escribirá aquí."
        },
        "rewriteText": {
            "title": "Reescribir texto",
            "description": "Resalte el texto en otra aplicación donde esté escribiendo y luego regrese aquí y describa cómo desea que se reescriba.",
            "label": "Describe cómo quieres reescribir el texto.",
            "inputLabel": "Introduzca el texto para reescribir"
        },
        "translateText": {
            "title": "Traducir texto",
            "description": "Ingrese el texto a traducir o Cephable utilizará automáticamente el texto que haya resaltado.",
            "label": "Introduzca el texto a traducir",
            "languageLabel": "Idioma al que traducir"
        },
        "noteTaker": {
            "title": "Tomador de notas",
            "description": "Deje que Cephable grabe y transcriba localmente sus reuniones o conversaciones"
        },
        "documentChat": {
            "title": "Chat de documentos",
            "description": "Interactúe y consulte documentos para obtener información rápidamente."
        },
        "highlightText": {
            "title": "Usar texto resaltado",
            "description": "Cephable puede usar automáticamente el texto que hayas resaltado en cualquier aplicación para realizar tareas como resumir, reescribir o traducir. También puedes introducir el texto manualmente si lo prefieres.",
            "label": "Introduzca el texto a utilizar",
            "placeholder": "También puedes resaltar texto en otra aplicación y volver aquí para usarlo."
        },
        "pasteText": {
            "title": "Pegar texto",
            "description": "Cephable puede usar automáticamente el texto que has copiado al portapapeles para realizar tareas como resumir, reescribir o traducir. También puedes introducir el texto manualmente si lo prefieres.",
            "label": "Introduzca el texto a utilizar",
            "placeholder": "También puedes resaltar texto en otra aplicación y volver aquí para usarlo."
        },
        "clearCache": "Si observa problemas con la generación, borre el caché y los recursos de la Configuración de generación de texto y vuelva a intentarlo.",
        "transcribeAudio": {
            "title": "Transcribir audio",
            "description": "Convierta archivos de audio o video en texto usando la transcripción de IA.",
            "inputMethod": "Elija el método de entrada",
            "localFile": "Archivo local",
            "url": "URL",
            "selectFile": "Seleccionar archivo de audio/video",
            "urlLabel": "URL de audio/vídeo",
            "transcribe": "Transcribir",
            "result": "Resultado de la transcripción",
            "invalidFileType": "Seleccione un archivo de audio o vídeo válido (mp3, wav, ogg, mp4, webm, mov, avi)",
            "error": "Error de transcripción",
            "history": {
                "title": "Historial de transcripción",
                "description": "Vea y administre sus transcripciones guardadas.",
                "viewHistory": "Ver historial",
                "empty": "Aún no hay transcripciones. ¡Empieza a transcribir para construir tu historia!",
                "titleLabel": "Título (opcional)",
                "titlePlaceholder": "Introduzca un título para esta transcripción",
                "textLabel": "Texto de transcripción",
                "confirmDelete": "¿Está seguro de que desea eliminar esta transcripción?"
            }
        },
        "aiWorkflows": {
            "description": "Automatiza las tareas de tu escritorio y navegador con IA. Simplemente describe lo que quieres lograr y observa cómo Cephable ejecuta las acciones.",
            "label": "Describe lo que quieres lograr",
            "status": {
                "idle": "Esperando tus instrucciones...",
                "initializing": "Preparando las cosas...",
                "planning": [
                    "Haciendo un plan...",
                    "Desglosando su solicitud...",
                    "Trazando los pasos...",
                    "Organizando el flujo de trabajo...",
                    "Preparando la estrategia...",
                    "Creando un plan de acción...",
                    "Descubriendo la mejor manera de ayudarte...",
                    "Determinar cómo abordar esto...",
                    "Analizando su solicitud...",
                    "Planificando la ejecución..."
                ],
                "thinking": [
                    "Pensamiento...",
                    "Analizando su solicitud...",
                    "Descubriendo la mejor manera de ayudarte...",
                    "Determinar qué hacer a continuación...",
                    "Procesando los pasos anteriores...",
                    "Trabajando en tu solicitud...",
                    "Obteniendo detalles...",
                    "Revisando el plan...",
                    "Considerando las opciones...",
                    "Crear, evaluar, decidir..."
                ],
                "waitingForUser": "Necesitamos su aportación para continuar.",
                "completed": "¡Éxito!",
                "failed": "Tu solicitud falló. Inténtalo de nuevo.",
                "canceled": "Su solicitud fue cancelada",
                "terminated": "Detenido. Esperando tus instrucciones...",
                "thinkingInteractive": [
                    "Considerando el siguiente paso...",
                    "Repasando lo que hemos hecho hasta ahora...",
                    "Decidir qué hacer a continuación...",
                    "Analizando los resultados...",
                    "Planificando la continuación...",
                    "Evaluando las opciones...",
                    "Descubriendo cuál es el mejor siguiente paso...",
                    "Trabajando en la siguiente parte de tu solicitud...",
                    "Trabajando en los próximos pasos...",
                    "Procesando los resultados del paso anterior..."
                ],
                "tools": {
                    "click_element_by_index": {
                        "executing-start": "Haciendo clic en el botón correspondiente...",
                        "executing-complete": "Hice clic en {{params.index}}."
                    },
                    "click_element": {
                        "executing-start": "Haciendo clic en el número resaltado...",
                        "executing-complete": "Hice clic en {{params.elementName}}."
                    },
                    "copy_selection": {
                        "executing-start": "Recopilando contexto...",
                        "executing-complete": "Tengo el contexto, listo para la siguiente parte de tu solicitud."
                    },
                    "create_file": {
                        "executing-start": "Creando un archivo...",
                        "executing-complete": "Creé un archivo llamado {{params.fileName}}."
                    },
                    "draft_email": {
                        "executing-start": "Redactar un correo electrónico...",
                        "executing-complete": "Redacté un correo electrónico sobre {{params.subject}}."
                    },
                    "execute_app_action": {
                        "executing-start": "Ejecutando {{params.actionName}}...",
                        "executing-complete": "{{params.actionName}} completado."
                    },
                    "find_all_text": {
                        "executing-start": "Buscando todo el contexto relevante sobre {{params.searchText}}...",
                        "executing-complete": "Encontré todo el contexto relevante sobre {{params.searchText}}."
                    },
                    "find_and_select_text": {
                        "executing-start": "Buscando y seleccionando contexto relevante sobre {{params.searchText}}...",
                        "executing-complete": "Encontré y seleccioné contexto relevante sobre {{params.searchText}}."
                    },
                    "generate_text": {
                        "executing-start": "Creando contenido...",
                        "executing-progress": "Creando contenido...{{progress}}%",
                        "executing-complete": "He creado el contenido solicitado."
                    },
                    "get_all_interactive_elements": {
                        "executing-start": "Escaneando para obtener más contexto...",
                        "executing-complete": "Entiendo con qué puedo interactuar."
                    },
                    "get_all_text_elements_content": {
                        "executing-start": "Leyendo para obtener más contexto...",
                        "executing-complete": "Entiendo qué contenido de texto está disponible."
                    },
                    "get_all_text_elements_names": {
                        "executing-start": "Leyendo para obtener más contexto...",
                        "executing-complete": "Entiendo qué contenido de texto está disponible."
                    },
                    "get_available_profile_actions": {
                        "executing-start": "Comprobando qué controles están disponibles en esta aplicación...",
                        "executing-complete": "Entiendo lo que puedo hacer en esta aplicación."
                    },
                    "get_document_content": {
                        "executing-start": "Leyendo para obtener más contexto...",
                        "executing-complete": "Tengo el contexto, listo para la siguiente parte de tu solicitud."
                    },
                    "get_installed_apps": {
                        "executing-start": "Decidir qué aplicación es relevante para su solicitud...",
                        "executing-complete": "Sé qué aplicaciones puedo usar."
                    },
                    "get_running_app_names": {
                        "executing-start": "Decidir qué aplicación es relevante para su solicitud...",
                        "executing-complete": "Sé qué aplicaciones puedo usar."
                    },
                    "get_selected_text": {
                        "executing-start": "Leyendo el contenido seleccionado...",
                        "executing-complete": "Tengo contexto sobre el contenido seleccionado."
                    },
                    "get_stored_content": {
                        "executing-start": "Recopilando contexto...",
                        "executing-complete": "Tengo el contexto, listo para la siguiente parte de tu solicitud."
                    },
                    "keyboard_shortcut": {
                        "executing-start": "Recopilando contexto...",
                        "executing-complete": "Tengo el contexto, listo para la siguiente parte de tu solicitud."
                    },
                    "open_app": {
                        "executing-start": "Abriendo {{params.appName}}...",
                        "executing-complete": "Abrí {{params.appName}}."
                    },
                    "open_webpage": {
                        "executing-start": "Abriendo {{params.url}}...",
                        "executing-complete": "Abrí {{params.url}}."
                    },
                    "paste_content": {
                        "executing-start": "Escribiendo...",
                        "executing-complete": "Terminé de escribir."
                    },
                    "respond_to_user": {
                        "executing-start": "Completando su solicitud...",
                        "executing-complete:": "He completado tu solicitud."
                    },
                    "search_and_open_file": {
                        "executing-start": "Buscando el archivo {{params.query}} y abriéndolo...",
                        "executing-complete": "Busqué el archivo {{params.query}} y lo abrí."
                    },
                    "search_browser": {
                        "executing-start": "Buscando en la web {{params.query}}...",
                        "executing-complete": "Busqué en la web {{params.query}}."
                    },
                    "select_all_text": {
                        "executing-start": "Seleccionando todo el texto...",
                        "executing-complete": "Seleccioné todo el texto."
                    },
                    "summarize_text": {
                        "executing-start": "Resumiendo el texto...",
                        "executing-progress": "Resumiendo...{{progress}}%",
                        "executing-complete": "Resumí el texto."
                    },
                    "translate_text": {
                        "executing-start": "Traduciendo el texto a {{params.targetLanguage}}...",
                        "executing-progress": "Traduciendo...{{progress}}%",
                        "executing-complete": "Traduje el texto a {{params.targetLanguage}}."
                    },
                    "type_stored_content": {
                        "executing-start": "Escribiendo...",
                        "executing-complete": "Terminé de escribir."
                    },
                    "type_text": {
                        "executing-start": "Escribiendo...",
                        "executing-complete": "Terminé de escribir."
                    },
                    "write_file_content": {
                        "executing-start": "Escribiendo en el archivo...",
                        "executing-complete": "Terminé de escribir en el archivo {{params.fileName}}."
                    },
                    "unknown": {
                        "executing-start": "Me encontré con un problema y probé una estrategia diferente...",
                        "executing-complete": "Probé una estrategia diferente."
                    }
                },
                "networkError": "Se perdió la conexión al descargar el modelo. Comprueba tu conexión a internet y vuelve a intentarlo enviando un mensaje o reiniciando la aplicación.",
                "executing-org-block": "No se puede {{params.toolName}} porque la interacción con {{params.appOrDomain}} está bloqueada por la organización.",
                "executing-destructive-block": "La interacción con {{params.elementName}} está bloqueada. Por favor, revise y realice esta acción manualmente.",
                "executing-type-focus-block": "Tuve un problema al escribir el contenido. Se copió al portapapeles; por favor, péguelo manualmente."
            },
            "ready": {
                "waiting": "AI Workflows está listo. Esperando tus instrucciones.",
                "execute": "Los flujos de trabajo de IA están listos. A partir de tu solicitud..."
            },
            "start": "Comenzar",
            "progress": "Laboral...",
            "introModal": {
                "description": "Ahora puedo automatizar las tareas de tu ordenador y navegador. Solo dime qué quieres que haga y yo me encargaré de todo. Me ejecuto de forma privada en tu dispositivo, así que tus datos son tuyos. Para empezar, necesito descargar un modelo de IA local. Descárgalo ahora para que esté listo, o lo haré cuando inicies tu primer flujo de trabajo.",
                "confirm": "Descargar ahora",
                "cancel": "Saltar por ahora",
                "title": "Los flujos de trabajo de IA están disponibles."
            },
            "title": "Sus flujos de trabajo de IA están listos."
        },
        "generatedByAI": "Desarrollado con inteligencia artificial en el dispositivo, revise para verificar su precisión.",
        "networkError": "Se perdió la conexión al descargar el modelo. Comprueba tu conexión a internet y vuelve a intentarlo enviando un mensaje o reiniciando la aplicación.",
        "genericError": "Se ha producido un error inesperado. Por favor, inténtelo de nuevo.",
        "download": {
            "title": "Descarga modelos de IA para desbloquear más funcionalidades.",
            "description": "Para usar las tareas inteligentes, es necesario descargar un modelo local en tu dispositivo. Esto garantiza que tus datos permanezcan privados y nunca se envíen a la nube.",
            "confirm": "Descargar",
            "cancel": "Ahora no",
            "includeWorkflows": "Descargue también modelos de flujo de trabajo de IA para una automatización avanzada."
        }
    },
    "inputMethod": "Método de entrada:",
    "hotkey": {
        "title": "Botón de acción rápida",
        "titlePlural": "Botones de acción rápida",
        "titlePanel": "Acciones rápidas",
        "label": "Nombre para mostrar del botón de acción rápida",
        "placeholder": "Nombre para mostrar",
        "question": "¿Cómo te gustaría llamar a este botón?",
        "when": "Cuando toco...",
        "description": "Los botones de acción rápida son botones personalizables que puedes pulsar para realizar acciones relevantes en tu aplicación. Con una sola pulsación puedes ejecutar varios pasos o una sola acción.",
        "usagePrompt": "Los botones de acción rápida son botones personalizables que puedes pulsar para realizar acciones relevantes en tu aplicación. Puedes añadir, eliminar o editar los nombres desde la página principal de configuración de controles de la aplicación.",
        "reorder": "Puede reorganizar el orden utilizando los botones de subir y bajar.",
        "emptyTitle": "Sin botones de acción rápida",
        "edit": "Editar botones de acción rápida",
        "tap": "Toque {{value}}",
        "copySuffix": "{{name}}_copiar",
        "hotkeysOnly": "Botones personalizados",
        "allControls": "Todos los controles de la aplicación",
        "show": "Mostrar botones de acción rápida",
        "deprecatedDialog": {
            "title": "Los controles de tu aplicación requieren una actualización.",
            "description2": "Solo necesitas una actualización rápida (literalmente, un segundo) y disfrutarás de una experiencia de personalización de botones impecable. Olvídate de los pasos adicionales y dale la bienvenida a una interfaz más intuitiva. ¿Listo para el cambio?",
            "confirm": "¡Vamos a hacerlo!",
            "description1": "Parece que estás usando controles de app antiguos con botones de acción rápida. ¡Tenemos novedades emocionantes para ti! Hemos renovado el sistema para que crear y editar botones de acción rápida sea muy fácil, sin necesidad de tener que recurrir a ajustes avanzados."
        },
        "demo": {
            "title": "Botones de acción rápida de demostración",
            "step1": "Activar los botones de acción rápida",
            "step2": "Utilice los ejemplos que aparecen a continuación para controlar el bloque de texto.",
            "command1": "Presione el botón 1 para “Agrandar el texto”",
            "command2": "Presione el botón 2 para poner el texto en negrita",
            "command3": "",
            "continue": "Continuar con los botones de acción rápida",
            "description": "El área de demostración a continuación le permitirá probar los botones de acción rápida. La demostración se limita específicamente al control de esta área de texto."
        },
        "example": {
            "title": "Ejemplos de botones de acción rápida",
            "command1": "Toque Pausa",
            "example1": "Ejemplo de “pausar video”",
            "command2": "Toque hacia adelante",
            "example2": "Ejemplo de “alejar”",
            "command3": "Toque Detener",
            "example3": "Ejemplo “cerrar ventana”",
            "description": "Estos ejemplos demuestran la versatilidad de los botones de acción rápida para controlar tu dispositivo o conexión. Permiten ejecutar comandos, navegar por interfaces o realizar acciones con un simple toque."
        },
        "emptySearch": "No hay acciones rápidas que coincidan con este criterio.",
        "empty": "Parece que actualmente no tienes ninguna acción rápida.",
        "emptyLong": "No hay botones de acción rápida configurados en estos controles de la aplicación. Una vez que los agregues o elijas controles con uno, aparecerán aquí."
    },
    "reset": "Reiniciar",
    "info": "Más información",
    "device": {
        "title": "Conexión",
        "titlePlural": "Conexiones",
        "status": {
            "title": "Estado de la conexión:",
            "connected": {
                "application": "Aplicación conectada",
                "connection": "Conectado",
                "device": "Dispositivo conectado",
                "game": "Juego conectado"
            },
            "disconnected": {
                "application": "Aplicación desconectada",
                "connection": "Desconectado",
                "device": "Dispositivo desconectado",
                "game": "Juego desconectado"
            }
        },
        "running": "Correr",
        "offline": "Desconectado",
        "otherDevices": "Otras conexiones de salida",
        "currentStatus": "Estado actual:",
        "connectionStatus": "Estado de la conexión:",
        "profileStatus": "Controles de la aplicación actual:",
        "name": {
            "title": "Nombre de la conexión",
            "question": "¿Cómo quieres llamar a esta conexión?",
            "description": "Dale un nombre a tu conexión para que puedas encontrarla fácilmente más tarde.",
            "placeholder": "nombre de la conexión",
            "edit": "Editar el nombre de la conexión"
        },
        "updates": {
            "title": "Actualizaciones de conexión",
            "settings": "Configuración de actualización de conexión",
            "description": "Verifique las actualizaciones del firmware de conexión y cambie la configuración de actualización automática",
            "edit": "Editar la configuración de actualización",
            "check": {
                "title": "Buscar actualizaciones",
                "processing": "¡Buscando actualizaciones! Puede tardar unos minutos y tu conexión podría reiniciarse durante las actualizaciones.",
                "description": "Pulsa para buscar actualizaciones para tu conexión. Si hay una actualización disponible y tu conexión está activa, empezará a actualizarse. Las actualizaciones pueden tardar unos minutos."
            },
            "auto": {
                "title": "Actualizar automáticamente",
                "description": "Con esta configuración activada, tu conexión se actualizará automáticamente al conectarte a la red eléctrica, a una red wifi y al tener una actualización disponible. Si está desactivada, debes pulsar el botón de actualización para obtener la última versión.",
                "option": "¿Utilizar actualización automática?"
            }
        },
        "delete": {
            "title": "Desvincular {{name}}",
            "titleLong": "Desvincular de la cuenta",
            "description": "Al desvincular Cephable, se desconecta de este ordenador o juego y se elimina de tu cuenta. Ya no podrás conectarte, enviar comandos ni actualizarlo. Esta acción no se puede deshacer, pero puedes crear una nueva conexión al mismo ordenador o juego si quieres volver a usarlo en el futuro.",
            "confirm": "¿Estás seguro de que deseas desvincular esta conexión?",
            "confirmLong": "¿Seguro que desea cancelar y restablecer esta conexión? Ya no podrá conectarse, enviar comandos ni actualizarla. Después de cancelar y restablecer esta conexión, cualquier otra persona podrá configurarla desde cero.",
            "confirmButton": "Sí, elimine esta conexión."
        },
        "manage": {
            "title": "Haga clic para ver y administrar los detalles de sus conexiones.",
            "description": "",
            "name": "Personalice el nombre de su conexión para una gestión más sencilla."
        },
        "error": {
            "save": "Error al guardar la conexión.",
            "load": "Error al cargar la conexión.",
            "add": "Error al agregar conexión.",
            "delete": "Error al eliminar la conexión.",
            "updates": "Error al comprobar actualizaciones.",
            "connection": "No se ha establecido la conexión. Asegúrate de que esté conectada antes de volver a intentarlo.",
            "deleteLong": "No pudimos eliminar esta conexión de tu cuenta. Si vuelves a iniciar sesión, es posible que tengas que eliminarla manualmente en la configuración de conexión."
        },
        "success": {
            "save": "Conexión guardada.",
            "add": "Conexión agregada.",
            "delete": "Conexión eliminada."
        },
        "description": "Cephable admite múltiples dispositivos y conexiones. Puedes administrar la configuración o seleccionar cualquiera de ellas desde aquí. Este ordenador siempre será tu conexión principal. Puedes añadir más conexiones posteriormente.",
        "swap": {
            "titlePlural": "Conexiones de intercambio"
        },
        "control": {
            "button": "Control {{name}}",
            "description": {
                "application": "Controla esta aplicación conectada con tu voz, acciones rápidas, movimientos de cabeza y más. Por ejemplo, si dices \"Guardar\", se guardará en la aplicación en ejecución.",
                "connection": "Controla esta conexión con tu voz, acciones rápidas, movimientos de cabeza y más. Por ejemplo, si dices \"Guardar\", se guardará la conexión activa.",
                "device": "Controla este dispositivo conectado con tu voz, acciones rápidas, movimientos de cabeza y más. Por ejemplo, si dices \"Abrir Spotify\", se abrirá Spotify en el dispositivo en funcionamiento.",
                "game": "Controla este juego conectado con tu voz, acciones rápidas, movimientos de cabeza y más. Por ejemplo, si dices \"¡Ya!\", el jugador se moverá en un juego de carrera."
            },
            "generic": "Conexión de control"
        },
        "titleShort": "Conectar",
        "titleLong": "Conexiones y extensiones",
        "viewAll": "Ver todas las conexiones",
        "add": {
            "short": "Extender",
            "title": "Agregar una nueva conexión o extensión",
            "description": "Las conexiones y extensiones son maneras adicionales de mejorar tu experiencia con Cephable. Puedes agregar nuevas conexiones para conectarte a más dispositivos, aplicaciones o juegos. Lleva tu experiencia con Cephable al siguiente nivel agregando conexiones y extensiones.",
            "action": "Agregar una nueva conexión",
            "notAvailable": "Esta conexión o extensión no está disponible públicamente actualmente. Esto suele ocurrir al trabajar con extensiones generadas por el usuario. Vuelva a consultarla más tarde.",
            "isNotPublic": "VISTA PREVIA: Esta extensión se encuentra en versión preliminar para desarrolladores y podría estar incompleta. Los desarrolladores deben completar todos los pasos antes del lanzamiento público. Los usuarios pueden consultar la versión completa más adelante."
        },
        "new": "¡Tienes una nueva conexión!",
        "newLong": "¡Tienes una nueva conexión! Para empezar a usarla, selecciónala en el menú de abajo."
    },
    "explore": "Explorar",
    "shortcuts": {
        "title": "Atajos globales",
        "description": "Personalice los atajos de teclado para acceder rápidamente a los controles de Cephable desde cualquier lugar de su sistema.",
        "info": "Estos atajos funcionan globalmente y se pueden usar incluso cuando Cephable no es la ventana activa.",
        "shortcut": "Atajo",
        "toggleMicrophone": "Activar o desactivar el micrófono",
        "toggleDictation": "Activar o desactivar el modo de dictado",
        "toggleVoiceControl": "Activar o desactivar el modo de control por voz",
        "togglePanel": "Panel de alternancia",
        "registrationFailed": "Algunos accesos directos globales no se registraron. Es posible que otra aplicación los esté usando.",
        "record": {
            "title": "Acceso directo a grabaciones",
            "start": "Haga clic para grabar",
            "listening": "Presione la combinación de teclas deseada...",
            "pressKeys": "Presione las teclas ahora"
        },
        "formatHint": "Seleccione al menos una tecla modificadora ({{modifierKey}}, {{modifierKey2}}, Shift) y otra tecla."
    },
    "gamepad": {
        "title": "Compatibilidad con gamepad",
        "description": "Configurar la salida del gamepad y joystick para juegos de PC",
        "driver": {
            "description": "Para admitir las salidas de los mandos de juego, Cephable necesita descargar e instalar un controlador externo llamado ViGEm. Este controlador habilita la funcionalidad del mando virtual de Xbox 360, que los juegos reconocen de forma nativa.",
            "installed": "Controlador de juego instalado: ¡Listo para usar las salidas del gamepad! Si el problema persiste, puedes intentar reinstalar el controlador.",
            "notInstalled": "El controlador del controlador de juego no está instalado",
            "install": "Instalar el controlador del controlador de juego",
            "reinstall": "Reinstalar el controlador del controlador de juego",
            "installing": "Instalación del controlador de juego ViGEm...",
            "installSuccess": "¡El controlador del mando ViGEm se instaló correctamente! Ya puedes usar las salidas del mando en tus controles.",
            "installFailed": "No se pudo instalar el controlador de ViGEm. Inténtelo de nuevo o instálelo manualmente desde el sitio web de ViGEm."
        },
        "platform": {
            "unsupported": "Plataforma no compatible con las funciones del gamepad",
            "unsupportedDescription": "La función de salida del gamepad actualmente solo es compatible con sistemas Windows x64. La compatibilidad con Windows ARM64 aún no está disponible debido a limitaciones del SDK."
        },
        "usage": "Una vez instalado el controlador del controlador de juego, puedes usar los movimientos del joystick y las pulsaciones de los botones del gamepad en tus macros y comandos de voz para controlar los juegos."
    },
    "youtube": {
        "unavailable": {
            "title": "Vídeo no disponible",
            "description": "Este vídeo no está disponible actualmente. Vuelve a comprobarlo más tarde.",
            "retry": "Rever"
        },
        "watch": {
            "title": "Ups.",
            "description": "Parece que hubo un problema al cargar el video. Puedes verlo directamente en YouTube.",
            "button": "Mira en YouTube"
        },
        "offline": {
            "title": "Vídeo no disponible",
            "description": "Este video de YouTube requiere conexión a internet para cargarse. Comprueba tu conexión y vuelve a intentarlo."
        }
    },
    "metrics": {
        "download": {
            "success": "Se accedió exitosamente al archivo de métricas.",
            "manualPath": "Archivo de métricas disponible en: {{path}}",
            "error": "Error al descargar el archivo de métricas.",
            "noFile": "No se encontró ningún archivo de métricas."
        },
        "clear": {
            "success": "Archivo de métricas borrado exitosamente.",
            "error": "Error al borrar el archivo de métricas.",
            "noFile": "No se encontró ningún archivo de métricas para borrar.",
            "confirm": "¿Seguro que desea borrar todos los datos de métricas? Esta acción no se puede deshacer."
        }
    },
    "suggestedPrompts": {
        "title": "Indicaciones sugeridas",
        "description": "Personalice las indicaciones sugeridas que aparecen en las tareas de IA para ayudarlo a comenzar rápidamente.",
        "edit": "Editar indicaciones sugeridas",
        "generate": "Generar texto",
        "rewrite": "Reescribir texto",
        "addGenerate": "Agregar un mensaje de generación",
        "addRewrite": "Agregar una solicitud de reescritura",
        "remove": "Eliminar mensaje",
        "generatePlaceholder": "Introduzca un mensaje para generar texto...",
        "rewritePlaceholder": "Introduzca un mensaje para reescribir el texto...",
        "suggested": "Indicaciones sugeridas",
        "suggestedFor": "Sugerido para {{profileName}}",
        "seeAll": "Ver todas las indicaciones",
        "showLess": "Mostrar menos",
        "allPrompts": "Todas las indicaciones",
        "customFor": "Avisos personalizados para {{profileName}}",
        "defaultPrompts": "Indicaciones predeterminadas",
        "defaultGenerate": [
            "Un correo electrónico profesional presentando nuestro nuevo producto.",
            "Una agenda de reunión para la discusión del equipo de la próxima semana.",
            "Esquema de propuesta de proyecto para una nueva iniciativa",
            "Una plantilla de carta comercial formal",
            "Una sección de documentación técnica",
            "Introducción al manual del usuario",
            "Descripción general del documento de capacitación",
            "Un borrador de documento de política",
            "Un correo electrónico de seguimiento después de una reunión",
            "Un mensaje de agradecimiento a un cliente",
            "Un correo electrónico de actualización del estado del proyecto",
            "Una invitación a un evento de la empresa",
            "Un correo electrónico recordatorio para las próximas fechas límite",
            "Un correo electrónico de bienvenida para los nuevos miembros del equipo.",
            "Un correo electrónico de disculpa por la interrupción del servicio.",
            "Introducción a un boletín informativo",
            "Una lista de ideas para campañas de marketing",
            "Soluciones creativas para mejorar la productividad del equipo",
            "Ideas para actividades de retiro de empresa",
            "Conceptos para una nueva función de la aplicación móvil",
            "Sugerencias para mejorar la experiencia del cliente",
            "Ideas de innovación para el desarrollo de nuestros productos",
            "Ideas de contenido para publicaciones en redes sociales",
            "Temas de talleres para el desarrollo profesional",
            "Una función que valida la entrada del usuario",
            "Una consulta de base de datos para la gestión de usuarios",
            "Código de manejo de errores para solicitudes de API",
            "Una plantilla de archivo de configuración",
            "Comentarios que explican un algoritmo complejo",
            "Casos de prueba unitaria para una nueva característica",
            "Documentación para puntos finales de API",
            "Un script para la implementación automatizada"
        ],
        "defaultRewrite": [
            "Haz que este texto sea más conciso y directo.",
            "Ampliar este resumen con más detalles",
            "Reformatee esto como una lista numerada",
            "Convertir esto en viñetas",
            "Reestructura esto en párrafos claros.",
            "Haga que este texto sea más fácil de escanear rápidamente",
            "Organice esta información jerárquicamente",
            "Formatee esto como una guía paso a paso",
            "Haz que este mensaje sea más profesional y formal.",
            "Reescribe esto para que suene más informal y amigable.",
            "Ajuste el tono para que sea más alentador.",
            "Haz que este sonido sea más seguro y asertivo.",
            "Suavizar el tono para ser más diplomático",
            "Añade entusiasmo y energía a este texto.",
            "Hazlo más empático y comprensivo.",
            "Reescribir con un tono más colaborativo",
            "Simplifique esto para una audiencia general.",
            "Haga esta explicación más técnica y detallada.",
            "Descomponga este concepto complejo en términos más simples",
            "Añadir más contexto e información de fondo",
            "Resuma esto en conclusiones clave",
            "Desarrolle los puntos principales con ejemplos.",
            "Hazlo más accesible para principiantes.",
            "Condense esto manteniendo la información esencial.",
            "Mejorar la claridad y la legibilidad",
            "Hazlo más atractivo e interesante.",
            "Ajustar para una mejor gramática y fluidez",
            "Reescribir para enfatizar los beneficios"
        ]
    },
    "accessibilityService": {
        "error": {
            "generic": "Error interno. Inténtelo de nuevo más tarde.",
            "elementNotFound": "No se encontró ningún resultado. Asegúrese de que la búsqueda exista y vuelva a intentarlo.",
            "highlightOnConflict": "Se encontraron varios elementos. Refine su comando para especificar cuál desea seleccionar.",
            "clickNotInitialized": "La función de búsqueda por nombre no está disponible por el momento. Si el problema persiste, póngase en contacto con el servicio de asistencia.",
            "platformUnsupported": "Las funciones de Voice Mouse no son compatibles con esta plataforma."
        },
        "clickWait": "Inicializando. Por favor, espere un momento y vuelva a intentarlo."
    },
    "deprecated": "Obsoleto",
    "view": "Vista",
    "aiWorkflows": {
        "settings": {
            "title": "Configuración de flujos de trabajo de IA",
            "description": "Configure los modelos y dispositivos de IA utilizados para los flujos de trabajo de IA. Los flujos de trabajo de IA le permiten automatizar tareas de escritorio y navegador mediante IA en el dispositivo.",
            "configType": {
                "title": "Tipo de configuración del modelo",
                "description": "Seleccione el tipo de configuración de modelo que se usará para los flujos de trabajo de IA. Cada configuración está optimizada para distintos modelos.",
                "label": "Tipo de configuración"
            },
            "reasoningModel": {
                "title": "Modelo de razonamiento",
                "description": "Seleccione el modelo de IA que usará para las tareas de razonamiento y planificación. El modelo de razonamiento analiza sus solicitudes y crea planes de acción.",
                "label": "Modelo de razonamiento"
            },
            "reasoningDevice": {
                "label": "Dispositivo de razonamiento"
            },
            "generationModel": {
                "title": "Modelo de generación",
                "description": "Seleccione el modelo de IA que se usará para las tareas de generación de texto. El modelo de generación crea contenido de texto cuando lo requieren los flujos de trabajo.",
                "label": "Modelo de generación"
            },
            "generationDevice": {
                "label": "Dispositivo de generación"
            },
            "noModelsFound": "No se encontraron modelos",
            "terminate": {
                "title": "Recursos de flujo de trabajo claros",
                "description": "Haga clic para finalizar el flujo de trabajo y liberar recursos. Esto detendrá cualquier flujo de trabajo en ejecución y liberará la memoria utilizada por los modelos de IA.",
                "button": "Terminar trabajador de flujo de trabajo",
                "success": "Trabajador de flujo de trabajo finalizado.",
                "confirm": {
                    "title": "Terminar trabajador de flujo de trabajo",
                    "description": "¿Seguro que desea finalizar el flujo de trabajo? Esto detendrá cualquier flujo de trabajo en ejecución y liberará recursos.",
                    "confirm": "Sí, terminar"
                }
            },
            "autoWarm": {
                "title": "Flujos de trabajo de IA de inicio automático",
                "description": "Inicialice automáticamente los modelos de flujo de trabajo de IA al iniciar la aplicación. Los modelos se precargarán para que los flujos de trabajo puedan iniciarse de inmediato.",
                "option": "Iniciar automáticamente modelos de flujo de trabajo de IA al iniciar la aplicación"
            },
            "prompt": {
                "title": "Información adicional para flujos de trabajo de IA",
                "description": "Introduzca detalles adicionales para usar con la IA de Cephable al ejecutar flujos de trabajo. Utilice este campo para especificar sus preferencias de tono, comportamiento o cualquier otro detalle.",
                "field": "Aviso adicional",
                "placeholder": "Por ejemplo, siempre confirme antes de enviar correos electrónicos. Prefiera respuestas concisas. Use un lenguaje formal en los documentos."
            },
            "disableButtonNames": {
                "edit": "Interacciones de botones de bloqueo",
                "input": {
                    "label": "Nombre del botón",
                    "question": "¿Qué botones desea bloquear? Puede introducir el nombre completo o parcial de los botones.",
                    "remove": "Eliminar nombre del botón"
                },
                "button": "Botones de bloque",
                "description": "Controla con qué botones pueden interactuar los flujos de trabajo de IA. Por defecto, Cephable puede hacer clic en cualquier botón de la pantalla. Usa esta configuración para evitar acciones accidentales (por ejemplo, \"comprar\", \"eliminar\")."
            }
        }
    },
    "control": "Control",
    "automate": "Automatizar",
    "deviceCommandThrottled": {
        "macroLength": "Esta conexión no permite macros largas. Su macro se ha acortado automáticamente.",
        "commandCount": "Esta conexión limita la velocidad de envío de comandos. Espere y vuelva a intentarlo pronto."
    },
    "tos": {
        "title": "Actualización de los Términos de Servicio",
        "description": "Nuestros Términos de Servicio han sido actualizados. Lea y acepte los términos actualizados para continuar usando Cephable.",
        "effectiveDate": "Fecha de entrada en vigor: {{date}}",
        "accept": "Aceptar los Términos de Servicio",
        "loadError": "No se pueden cargar los Términos de Servicio. Vuelva a intentarlo.",
        "viewInBrowser": "Ver los Términos de Servicio en el navegador",
        "acceptCheckbox": "He leído y acepto los Términos de Servicio"
    }
}
